<template>
  <div>
    <el-dialog
      title="Certificado de exclusión: Retención Ganancias"
      :visible="showModalCertificationExgain"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationExgain = false"
    >
      <div v-if="this.certificationExgain[0]">
        <div class="box-body">
          <el-card shadow="always">
            <table
              class="tg"
              style="undefined;table-layout: fixed; width: 429px"
            >
              <colgroup>
                <col style="width: 207px" />
                <col style="width: 222px" />
              </colgroup>
              <tr>
                <th class="tg-0lax">Certificado:</th>
                <th class="tg-0lax">{{ certificationExgain[0].number }}</th>
              </tr>
              <tr>
                <td class="tg-j58y">Cuit:</td>
                <td class="tg-buh4">{{ certificationExgain[0].cuit }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Período fiscal:</td>
                <td class="tg-0lax">{{ certificationExgain[0].period }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Porcentaje:</td>
                <td class="tg-buh4">{{ certificationExgain[0].percentage }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Resolución:</td>
                <td class="tg-0lax">{{ certificationExgain[0].resolution }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Estado:</td>
                <td class="tg-buh4">{{ certificationExgain[0].state }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Fecha de Publicación:</td>
                <td class="tg-0lax">
                  {{ certificationExgain[0].publication }}
                </td>
              </tr>
              <tr>
                <td class="tg-buh4">Fecha de Vigencia:</td>
                <td class="tg-buh4">{{ certificationExgain[0].validity }}</td>
              </tr>
            </table>
          </el-card>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="closeCertificationExgain">
          Aceptar
        </button>
      </span>
    </el-dialog>
    <!--down-->
    <el-dialog
      title="Lista de certificados de exclusión: Retención Ganancias"
      :visible="showModalCertificationsExgainList"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationsExgainList = false"
    >
      <!--{{this.provider.certifExgain === true}}-->
      <!--<div v-if="provider && provider.certifExgain">-->
      <div class="box-body">
        <el-card shadow="always">
          <table style="undefined;table-layout: fixed; width: 429px">
            <colgroup>
              <col style="width: 140px" />
              <col style="width: 140px" />
              <col style="width: 135px" />
              <col style="width: 20px" />
            </colgroup>
            <tr>
              <th class="tg-0laxA">Nro Certificado:</th>
              <th class="tg-0laxA">Fecha de emisión:</th>
              <th class="tg-0laxA">Fecha de vigencia:</th>
            </tr>
            <tr
              v-for="item in certificationExgainList"
              :key="item.IdCertificationExGain"
            >
              <td class="td-buh4A">{{ item.number }}</td>
              <td class="td-buh4A">{{ item.publication }}</td>
              <td class="td-buh4A">{{ item.validity }}</td>
              <td class="td-buh4B">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-view"
                  @click="getCertificationExgain(item.IdCertificationExGain)"
                ></el-button>
              </td>
            </tr>
          </table>
        </el-card>
      </div>
      <!--</div>-->
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="closeCertificationsExgainList">
          Aceptar
        </button>
      </span>
    </el-dialog>
    <el-dialog
      title="Certificado de exención: RG2681"
      :visible="showModalCertificationRg2681"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationRg2681 = false"
    >
      <!--<div v-if="provider && provider.certifRg2681 && this.certificationRg2681[0]">-->
      <div v-if="this.certificationRg2681[0]">
        <div class="box-body">
          <el-card shadow="always">
            <table
              class="tg"
              style="undefined;table-layout: fixed; width: 429px"
            >
              <colgroup>
                <col style="width: 207px" />
                <col style="width: 222px" />
              </colgroup>
              <tr>
                <th class="tg-0lax">Cuit:</th>
                <th class="tg-0lax">{{ certificationRg2681[0].cuit }}</th>
              </tr>
              <tr>
                <td class="tg-buh4">Tipo de sujeto:</td>
                <td class="tg-buh4">{{ certificationRg2681[0].type }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Cod. Estado:</td>
                <td class="tg-0lax">{{ certificationRg2681[0].state }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Desc. Estado:</td>
                <td class="tg-buh4">
                  {{ certificationRg2681[0].stateDescription }}
                </td>
              </tr>
              <tr>
                <td class="tg-0lax">Fecha de Emisión del Certificado:</td>
                <td class="tg-0lax">{{ certificationRg2681[0].emision }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Fecha Adm. Formal:</td>
                <td class="tg-buh4">
                  {{ certificationRg2681[0].administrationDate }}
                </td>
              </tr>
              <tr>
                <td class="tg-0lax">Autoriza Deducción:</td>
                <td class="tg-0lax">{{ certificationRg2681[0].auth }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Obligado Pres. DDJJ:</td>
                <td class="tg-buh4">{{ certificationRg2681[0].ddjj }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Código Inciso:</td>
                <td class="tg-0lax">{{ certificationRg2681[0].subsection }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Vigencia desde:</td>
                <td class="tg-buh4">{{ certificationRg2681[0].since }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Vigencia hasta:</td>
                <td class="tg-0lax">{{ certificationRg2681[0].until }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Nro Certificado:</td>
                <td class="tg-buh4">{{ certificationRg2681[0].number }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Por orden judicial:</td>
                <td class="tg-0lax">{{ certificationRg2681[0].orderJud }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Fecha última modificación:</td>
                <td class="tg-buh4">
                  {{ certificationRg2681[0].modificationDate }}
                </td>
              </tr>
            </table>
          </el-card>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="closeCertificationRg2681">
          Aceptar
        </button>
      </span>
    </el-dialog>
    <el-dialog
      title="Datos adicionales del certificado"
      :visible="showModalCertificationDatosAdicionales"
      width="30%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationDatosAdicionales = false"
    >
      <div v-if="taxData.jurisdictions[activeJurisdiction]">
        <div style="margin-bottom: 20px">
          <el-date-picker
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            v-model="taxData.jurisdictions[activeJurisdiction].certificateFrom"
            type="date"
            placeholder="Seleccionar"
          >
          </el-date-picker>
        </div>
        <div style="margin-bottom: 20px">
          <el-date-picker
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            :picker-options="disabledDates"
            v-model="taxData.jurisdictions[activeJurisdiction].certificateTo"
            type="date"
            placeholder="Seleccionar"
          >
          </el-date-picker>
        </div>
        <div>
          <el-upload
            class="upload-demo"
            id="uploadCertificatePdf"
            :ref="'jurisdictions\[' + jurId + '\]\[\'certificatePdf\'\]'"
            :action="serverURI + 'api/uploadFile'"
            :auto-upload="true"
            accept="application/pdf"
            :on-success="handlePdfCertificate"
            :on-exceed="handleExceed"
            :data="{
              folder: 'altaProveedor',
            }"
            :limit="1"
          >
            <el-button slot="trigger" size="small" type="primary"
              >Seleccionar archivo</el-button
            >
            <div slot="tip" class="el-upload__tip">
              Solo se permiten archivos PDF
            </div>
          </el-upload>
          <span>
            <a
              v-if="taxData.jurisdictions[activeJurisdiction].certificatePdf"
              :href="taxData.jurisdictions[activeJurisdiction].certificatePdf"
              target="_blank"
              style="padding-right: 20px"
            >
              <i class="fa fa-file-pdf-o" /> Ver
            </a>
          </span>
          <span slot="footer" class="dialog-footer" style="float: right">
            <el-button
              type="primary"
              @click="showModalCertificationDatosAdicionales = false"
              >Confirmar</el-button
            >
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="Formulario 1276"
      :visible="showModalForm1276"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalForm1276 = false"
    >
      <div v-if="taxData.jurisdictions[activeJurisdiction]">
        <div>
          <el-upload
            class="upload-demo"
            id="uploadForm1276"
            :ref="'jurisdictions\[' + jurId + '\]\[\'form1276pdf\'\]'"
            :action="serverURI + 'api/uploadFile'"
            :auto-upload="true"
            accept="application/pdf"
            :on-success="handlePdfForm1276"
            :on-exceed="handleExceed"
            :data="{
              folder: 'altaProveedor',
            }"
            :limit="1"
          >
            <el-button slot="trigger" size="small" type="primary"
              >Seleccionar archivo</el-button
            >
            <div slot="tip" class="el-upload__tip">
              Solo se permiten archivos PDF
            </div>
          </el-upload>
          <span>
            <a
              v-if="taxData.jurisdictions[activeJurisdiction].form1276pdf"
              :href="taxData.jurisdictions[activeJurisdiction].form1276pdf"
              target="_blank"
              style="padding-right: 20px"
            >
              <i class="fa fa-file-pdf-o" /> Ver
            </a>
          </span>
          <span slot="footer" class="dialog-footer" style="float: right">
            <el-button type="primary" @click="showModalForm1276 = false"
              >Confirmar</el-button
            >
          </span>
        </div>
      </div>
    </el-dialog>
    <!--down-->
    <el-dialog
      title="Lista de certificados de exención: RG2681"
      :visible="showModalCertificationRg2681List"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationRg2681List = false"
    >
      <!--<div v-if="provider && provider.certifRg2681">-->
      <div class="box-body">
        <el-card shadow="always">
          <table style="undefined;table-layout: fixed; width: 429px">
            <colgroup>
              <col style="width: 140px" />
              <col style="width: 140px" />
              <col style="width: 135px" />
              <col style="width: 20px" />
            </colgroup>
            <tr>
              <th class="tg-0laxA">Nro Certificado:</th>
              <th class="tg-0laxA">Fecha de emisión:</th>
              <th class="tg-0laxA">Fecha de vigencia:</th>
            </tr>
            <tr
              v-for="item in certificationRg2681List"
              :key="item.idCertificationRG2681"
            >
              <td class="td-buh4A">{{ item.number }}</td>
              <td class="td-buh4A">{{ item.emision }}</td>
              <td class="td-buh4A">{{ item.until }}</td>
              <td class="td-buh4B">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-view"
                  @click="getCertificationRg2681(item.idCertificationRG2681)"
                ></el-button>
              </td>
            </tr>
          </table>
        </el-card>
      </div>
      <!--</div>-->
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="closeCertificationsRg2681List">
          Aceptar
        </button>
      </span>
    </el-dialog>
    <el-dialog
      title="Certificado de exclusión: Retención SUSS"
      :visible="showModalCertificationSuss"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationSuss = false"
    >
      <!--<div v-if="provider && provider.certifSuss && this.certificationSuss[0]">-->
      <div v-if="this.certificationSuss[0]">
        <div class="box-body">
          <el-card shadow="always">
            <table
              class="tg"
              style="undefined;table-layout: fixed; width: 429px"
            >
              <colgroup>
                <col style="width: 207px" />
                <col style="width: 222px" />
              </colgroup>
              <tr>
                <th class="tg-0lax">Certificado:</th>
                <th class="tg-0lax">{{ certificationSuss[0].number }}</th>
              </tr>
              <tr>
                <td class="tg-j58y">Cuit:</td>
                <td class="tg-buh4">{{ certificationSuss[0].cuit }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Período fiscal:</td>
                <td class="tg-0lax">{{ certificationSuss[0].period }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Porcentaje:</td>
                <td class="tg-buh4">{{ certificationSuss[0].percentage }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Resolución:</td>
                <td class="tg-0lax">{{ certificationSuss[0].resolution }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Estado:</td>
                <td class="tg-buh4">{{ certificationSuss[0].state }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Fecha de Publicación:</td>
                <td class="tg-0lax">{{ certificationSuss[0].since }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Fecha de Vigencia:</td>
                <td class="tg-buh4">{{ certificationSuss[0].until }}</td>
              </tr>
            </table>
          </el-card>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="closeCertificationSuss">
          Aceptar
        </button>
      </span>
    </el-dialog>
    <!--down-->
    <el-dialog
      title="Lista de certificados de exclusión: SUSS"
      :visible="showModalCertificationSussList"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationSussList = false"
    >
      <!--<div v-if="provider && provider.certifSuss">-->
      <div class="box-body">
        <el-card shadow="always">
          <table style="undefined;table-layout: fixed; width: 429px">
            <colgroup>
              <col style="width: 140px" />
              <col style="width: 140px" />
              <col style="width: 135px" />
              <col style="width: 20px" />
            </colgroup>
            <tr>
              <th class="tg-0laxA">Nro Certificado:</th>
              <th class="tg-0laxA">Fecha de emisión:</th>
              <th class="tg-0laxA">Fecha de vigencia:</th>
            </tr>
            <tr
              v-for="item in certificationSussList"
              :key="item.idCertificaction"
            >
              <td class="td-buh4A">{{ item.number }}</td>
              <td class="td-buh4A">{{ item.since }}</td>
              <td class="td-buh4A">{{ item.until }}</td>
              <td class="td-buh4B">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-view"
                  @click="getCertificationSuss(item.idCertificaction)"
                ></el-button>
              </td>
            </tr>
          </table>
        </el-card>
      </div>
      <!--</div>-->
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="closeCertificationsSussList">
          Aceptar
        </button>
      </span>
    </el-dialog>
    <el-dialog
      title="Certificado de agente de retención RG18: Retención I.V.A"
      :visible="showModalCertificationRg18"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationRg18 = false"
    >
      <!--<div v-if="provider && provider.certifRg18 && this.certificationRg18[0]">-->
      <div v-if="this.certificationRg18[0]">
        <div class="box-body">
          <el-card shadow="always">
            <table
              class="tg"
              style="undefined;table-layout: fixed; width: 429px"
            >
              <colgroup>
                <col style="width: 207px" />
                <col style="width: 222px" />
              </colgroup>
              <tr>
                <td class="tg-j58y">Cuit:</td>
                <td class="tg-buh4">{{ certificationRg18[0].cuit }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Razón Social:</td>
                <td class="tg-0lax">{{ certificationRg18[0].name }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">INCISO RG:</td>
                <td class="tg-buh4">{{ certificationRg18[0].type }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Fecha de Publicación:</td>
                <td class="tg-0lax">{{ certificationRg18[0].since }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Fecha de Vigencia:</td>
                <td class="tg-buh4">{{ certificationRg18[0].until }}</td>
              </tr>
            </table>
          </el-card>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="closeCertificationRg18">
          Aceptar
        </button>
      </span>
    </el-dialog>
    <!--down-->
    <el-dialog
      title="Lista de agente de retención: RG18"
      :visible="showModalCertificationRg18List"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationRg18List = false"
    >
      <!--<div v-if="provider && provider.certifSuss">-->
      <div class="box-body">
        <el-card shadow="always">
          <table style="undefined;table-layout: fixed; width: 429px">
            <colgroup>
              <col style="width: 207px" />
              <col style="width: 150px" />
            </colgroup>
            <tr>
              <th class="tg-0laxA">Fecha de emisión:</th>
              <th class="tg-0laxA">Fecha de vigencia:</th>
            </tr>
            <tr
              v-for="item in certificationRg18List"
              :key="item.idCertificationRG18"
            >
              <td class="td-buh4A">{{ item.since }}</td>
              <td class="td-buh4A">{{ item.until }}</td>
              <td class="td-buh4B">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-view"
                  @click="getCertificationRg18(item.idCertificationRG18)"
                ></el-button>
              </td>
            </tr>
          </table>
        </el-card>
      </div>
      <!--</div>-->
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="closeCertificationsRg18List">
          Aceptar
        </button>
      </span>
    </el-dialog>
    <el-dialog
      title="Certificado de exclusión RG17: Retención I.V.A"
      :visible="showModalCertificationRg17"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationRg17 = false"
    >
      <!--<div v-if="provider && provider.certifRg17 && this.certificationRg17[0]">-->
      <div v-if="this.certificationRg17[0]">
        <div class="box-body">
          <el-card shadow="always">
            <table
              class="tg"
              style="undefined;table-layout: fixed; width: 429px"
            >
              <colgroup>
                <col style="width: 207px" />
                <col style="width: 222px" />
              </colgroup>
              <tr>
                <td class="tg-j58y">Cuit:</td>
                <td class="tg-buh4">{{ certificationRg17[0].cuit }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Razón Social:</td>
                <td class="tg-0lax">{{ certificationRg17[0].name }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Porcentaje:</td>
                <td class="tg-buh4">{{ certificationRg17[0].percentage }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">INCISO RG:</td>
                <td class="tg-buh4">{{ certificationRg17[0].rg }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Tipo de Certificado:</td>
                <td class="tg-buh4">{{ certificationRg17[0].type }}</td>
              </tr>
              <tr>
                <td class="tg-0lax">Fecha de Publicación:</td>
                <td class="tg-0lax">{{ certificationRg17[0].since }}</td>
              </tr>
              <tr>
                <td class="tg-buh4">Fecha de Vigencia:</td>
                <td class="tg-buh4">{{ certificationRg17[0].until }}</td>
              </tr>
            </table>
          </el-card>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="closeCertificationRg17">
          Aceptar
        </button>
      </span>
    </el-dialog>
    <!--down-->
    <el-dialog
      title="Lista de certificados de exclusión: RG17"
      :visible="showModalCertificationRg17List"
      width="40%"
      :fullscreen="false"
      :lock-scroll="true"
      v-on:close="showModalCertificationRg17List = false"
    >
      <!--<div v-if="provider && provider.certifSuss">-->
      <div class="box-body">
        <el-card shadow="always">
          <table style="undefined;table-layout: fixed; width: 429px">
            <colgroup>
              <col style="width: 207px" />
              <col style="width: 150px" />
            </colgroup>
            <tr>
              <th class="tg-0laxA">Fecha de emisión:</th>
              <th class="tg-0laxA">Fecha de vigencia:</th>
            </tr>
            <tr
              v-for="item in certificationRg17List"
              :key="item.idCertificationRG17"
            >
              <td class="td-buh4A">{{ item.since }}</td>
              <td class="td-buh4A">{{ item.until }}</td>
              <td class="td-buh4B">
                <el-button
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-view"
                  @click="getCertificationRg17(item.idCertificationRG17)"
                ></el-button>
              </td>
            </tr>
          </table>
        </el-card>
      </div>
      <!--</div>-->
      <span slot="footer" class="dialog-footer">
        <button class="btn btn-primary" @click="closeCertificationsRg17List">
          Aceptar
        </button>
      </span>
    </el-dialog>
    <el-dialog
      title="Confirmar Alta de Proveedor"
      :visible.sync="terminosYCondVisible"
      width="80%"
      style="margin-top: -12vh; height: auto; overflow-y: hidden"
      :lock-scroll="true"
    >
      <div style="max-height: 60vh; overflow: auto">
        <p>{{ configuration }}</p>
        <br /><br />
      </div>
      <form @submit.prevent="">
        <div>
          <input
            type="checkbox"
            name="aceptoCodigoEtica"
            required
            style="width: 15px; float: left; margin-right: 5px"
            v-model="checked2"
          />
          Acepto el
          <a target="_blank" rel="noopener noreferrer" :href="codigoEtica"
            >Código de Ética y Conducta</a
          >.
        </div>
        <div>
          <input
            type="checkbox"
            name="aceptoTerminos"
            required
            style="width: 15px; float: left; margin-right: 5px"
            v-model="checked"
          />
          Acepto las políticas:
          <a
            target="_blank"
            rel="noopener noreferrer"
            :href="politicaAnticorrupcion"
            >Política Anticorrupción</a
          >
          y
          <a
            target="_blank"
            rel="noopener noreferrer"
            :href="politicaRelacionamiento"
            >Política de Relacionamiento con Funcionarios Públicos.</a
          >
        </div>
        <span slot="footer" class="dialog-footer">
          <button
            type="submit"
            v-on:click="submitFormSolicitud()"
            :disabled="!checked2 || !checked"
            v-bind:class="'btn btn-primary btn-lg ' + loading"
            style="position: relative; left: 45%"
          >
            Aceptar
          </button>
        </span>
      </form>
    </el-dialog>

    <h1 class="text-center" v-if="!paramError && !provider">
      SOLICITAR SER PROVEEDOR
    </h1>
    <p class="text-center" v-if="!paramError && !provider">
      Complete el formulario
    </p>
    <p class="text-center text-danger" style="font-weight:bold;font-size:15px">Usted está aprobando/rechazando los datos para que la empresa pueda operar en {{actualCountryFull}}</p>
    <div class="row">
      <el-button
        @click="$router.go(-1)"
        style="
          display: inline-block;
          float: right;
          transition: all 1s;
          margin-right: 30px;
          margin-top: 20px;
        "
      >
        <i class="fas fa-angle-left"></i>
        Volver
      </el-button>
    </div>

    <section class="content">
      <div class="row" v-if="paramError">
        <div class="col-md-12 text-center">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="info-box">
              <span class="info-box-icon bg-red"
                ><i class="ion ion-android-alert"></i
              ></span>
              <div class="info-box-content">
                <span class="info-box-text">Advertencia</span>
                <span class="info-box-info">{{ paramError }}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
      <div>
        <el-steps :active="step" finish-status="success" align-center>
          <el-step title="Datos Generales"></el-step>
          <el-step title="Datos Bancarios"></el-step>
          <el-step title="Datos Impositivos"></el-step>
          <el-step title="Usuario" v-if="!provider"></el-step>
        </el-steps>
      </div>
      <div class="row" v-if="!paramError">
        <div class="col-md-12">
          <div class="box box-info">
            <!-- Input Addons -->
            <div class="box-header with-border">
              <h3 class="box-title" v-if="step === 0">Datos Generales</h3>
              <span v-if="provider.generalData">
                <h5
                  style="text-align: right; margin-top: -3.3%"
                  v-if="step === 0"
                >
                  Ultima modificación: {{ provider.generalData.modifDate }}
                </h5></span
              >
              <h3 class="box-title" v-if="step === 1">Datos de Pago</h3>
              <h3 class="box-title" v-if="step === 2">Datos Impositivos</h3>
              <h3 class="box-title" v-if="step === 3">Usuario</h3>
            </div>
            <el-alert
              v-if="
                user &&
                user.isProvider &&
                provider &&
                provider[activeTab()].idCompanyDataStatus ===
                  status.ESPERANDO_CONFIRMACION
              "
              title="Etapa en verificacion"
              type="warning"
              description="Los datos de esta etapa estan siendo verificados."
              show-icon
            >
            </el-alert>
            <div
              class="col-md-12"
              v-if="
                (user &&
                user.isProvider &&
                provider &&
                provider[activeTab()].idCompanyDataStatus === status.ACEPTADO) ||
                (user &&
                !user.isProvider &&
                provider &&
                provider[activeTab()].idCompanyDataStatus === status.ESPERANDO_CONFIRMACION)
              "
            >
              <el-button
                style="float: left; margin-top: 1%"
                type="danger"
                v-if="!editing"
                @click="editData"
                >Editar</el-button
              >
              <el-button
                style="float: left"
                type="success"
                v-else
                @click="saveData"
                >Guardar</el-button
              >
              <el-button
                style="float: left"
                type="warning"
                v-if="editing === true"
                @click="cancelData"
                >Cancelar</el-button
              >
            </div>

            <div
              class="box-body"
              v-loading="!providerLoaded && this.user && this.idCompany"
            >
              <el-col style="width: 80%; margin-left: 10%">
                <el-row
                  style="height: 90px; padding-top: 20px; text-align: right"
                  v-if="provider && false"
                >
                  <el-tag
                    effect="dark"
                    style="font-size: 18px"
                    :type="statusType"
                  >
                    {{ getStatusNameOfTab() }}
                  </el-tag>
                </el-row>

                <el-form
                  v-if="step === 0"
                  :model="generalData"
                  ref="generalDataForm"
                  :disabled="disabledData"
                  :rules="rulesGeneralData"
                  label-position="left"
                  label-width="25%"
                  id="formDatosGenerales"
                  @submit.native.prevent=""
                >
                  <div class="info-box-content">
                    <p class="text-danger">
                      Los campos acompañados con asterisco(*) son obligatorios.
                    </p>
                  </div>
                  <h5 style=" margin-top: -3%">
                    Fecha de creación: {{ provider.creationDate }}
                  </h5>
                  <el-divider>Datos de la empresa</el-divider>

                  <el-form-item label="CUIT (sin guiones)" prop="cuit">
                    <el-col :span="23" style="padding-right: 20px">
                      <el-input
                        id="cuit"
                        type="text"
                        v-model.number="generalData.cuit"
                        maxlength="11"
                        show-word-limit
                        :disabled="dataAfip !== ''"
                      ></el-input>
                    </el-col>
                    <el-col :span="16" align="center">
                      <el-button
                        id="verificarAFIP"
                        v-if="!dataAfip"
                        size="mini"
                        :disabled="generalData.cuit.toString().length !== 11"
                        type="primary"
                        style=""
                        @click="verifyCuit"
                      >
                        Verificar AFIP
                      </el-button>
                      <el-button
                        size="mini"
                        type="warning"
                        @click="editCuit"
                        v-if="dataAfip && !this.provider"
                      >
                        Editar
                      </el-button>
                    </el-col>
                  </el-form-item>
                  <transition name="fade">
                    <div v-show="dataAfip">
                      <el-form-item
                        label="Razón Social / Denominación"
                        prop="company"
                      >
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            maxlength="255"
                            v-model="generalData.company"
                            :disabled="!editing"
                          ></el-input>
                        </el-col>
                        <!--<el-col :span="1" style="padding-left: 20px" v-if="provider.generalData.address != provider.logCompanyGeneralData.address">-->
                        <!--<el-tooltip placement="top">-->
                        <!--<div slot="content">Campo modificado</div>-->
                        <!--<i class="el-icon-info"></i>-->
                        <!--<i class="el-icon-time"></i>-->
                        <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                        <!--<el-tag type="warning">Modificado</el-tag>-->
                        <!--</el-tooltip>-->
                        <!--</el-col>-->
                      </el-form-item>

                      <el-form-item
                        label="Nombre de Fantasía"
                        prop="companyName"
                      >
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.companyName"
                            :disabled="!editing"
                            maxlength="255"
                          ></el-input>
                        </el-col>
                        <!--<el-col :span="1" style="padding-left: 20px" v-if="provider.generalData.address != provider.logCompanyGeneralData.address">-->
                        <!--<el-tooltip placement="top">-->
                        <!--<div slot="content">Campo modificado</div>-->
                        <!--<i class="el-icon-info"></i>-->
                        <!--<i class="el-icon-time"></i>-->
                        <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                        <!--<el-tag type="warning">Modificado</el-tag>-->
                        <!--</el-tooltip>-->
                        <!--</el-col>-->
                      </el-form-item>
                      <el-form-item label="Fecha de inicio de Actividades" prop="start_date">
                        <el-form-item>
                          <el-col :span="25" style="padding-right: 20px">
                            <el-date-picker
                              format="dd/MM/yyyy"
                              value-format="yyyy-MM-dd"
                              v-model="generalData.start_date"
                              type="date"
                              placeholder="Inicio de Actividades"
                              :disabled="!editing"
                              @change="saveDataToLocalStorage(generalData.start_date,'start_date')"
                            />
                          </el-col>
                        </el-form-item>
                      </el-form-item>

                    <el-form-item label="¿En qué central prestará el servicio?" prop="centrales">
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        id="centrales"
                        multiple
                        filterable
                        clearable
                        v-model="generalData.centrales"
                        :disabled="!editing"
                      >
                        <el-option
                          v-for="item in centrales"
                          :key="item.idCentral"
                          :label="item.central"
                          :value="item.idCentral"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                      <el-form-item label="Servicio / Actividad" prop="rubros">
                        <el-form-item>
                          <el-col :span="25" style="padding-right: 20px">
                            <el-select
                              multiple
                              filterable
                              clearable
                              v-model="generalData.rubros"
                              :disabled="!editing"
                            >
                              <el-option
                                v-for="item in services"
                                :key="item.idRubro"
                                :label="item.nombre"
                                :value="item.idRubro"
                              >
                              </el-option>
                            </el-select>
                          </el-col>
                          <!--<el-col :span="1" v-if="provider.generalData.address != provider.logCompanyGeneralData.address">-->
                          <!--<el-tooltip placement="top">-->
                          <!--<div slot="content">Campo modificado</div>-->
                          <!--<i class="el-icon-info"></i>-->
                          <!--<i class="el-icon-time"></i>-->
                          <!--<el-alert
                                type="info"
                                show-icon
                                center
                                style="height: 40px"
                                :closable="false">
                              </el-alert>-->
                          <!--<el-tag type="warning">Modificado</el-tag>-->
                          <!--</el-tooltip>-->
                          <!--</el-col>-->
                        </el-form-item>
                      </el-form-item>

                      <el-row>
                        <el-form-item label="Calle" prop="address">
                          <el-col :span="19" style="padding-right: 20px">
                            <el-input
                              type="text"
                              v-model="generalData.address"
                              :disabled="!editing"
                              maxlength="100"
                            ></el-input>
                          </el-col>
                          <el-col :span="4">
                            <el-form-item
                              label="Nº"
                              prop="addressNumber"
                              style="padding-right: 20px"
                            >
                              <el-input
                                type="text"
                                v-model="generalData.addressNumber"
                                :disabled="!editing"
                                maxlength="200"
                              ></el-input>
                            </el-form-item>
                          </el-col>
                          <span v-if="provider.generalData">
                            <el-col
                              :span="1"
                              style="padding-left: 20px"
                              v-if="
                                provider.logCompanyGeneralData &&
                                (provider.generalData.address !=
                                  provider.logCompanyGeneralData.address ||
                                  provider.generalData.addressNumber !=
                                    provider.logCompanyGeneralData
                                      .addressNumber)
                              "
                            >
                              <el-tooltip placement="top">
                                <div slot="content">Campo modificado</div>
                                <i class="el-icon-info"></i>
                              </el-tooltip>
                            </el-col>
                          </span>
                        </el-form-item>
                      </el-row>

                      <el-form-item label="Código Postal" prop="zipCode">
                        <el-col :span="23">
                          <el-input
                            style="padding-right: 20px"
                            type="text"
                            v-model="generalData.zipCode"
                            maxlength="20"
                            :disabled="!editing"
                          ></el-input>
                        </el-col>
                        <span v-if="provider.generalData">
                          <el-col
                            :span="1"
                            style="padding-left: 20px"
                            v-if="
                              provider.logCompanyGeneralData &&
                              provider.generalData.zipCode !=
                                provider.logCompanyGeneralData.zipCode
                            "
                          >
                            <el-tooltip placement="top">
                              <div slot="content">
                                Campo
                                <!--<br/>-->modificado
                              </div>
                              <i class="el-icon-info"></i>
                            </el-tooltip>
                          </el-col>
                        </span>
                      </el-form-item>

                      <el-form-item label="País" prop="idCountry">
                        <el-form-item>
                          <el-col :span="25" style="padding-right: 20px">
                            <el-select
                              id="country"
                              filterable
                              clearable
                              v-model="generalData.idCountry"
                              @change="updateProvinces"
                              :disabled="!editing"
                            >
                              <el-option
                                v-for="item in countries"
                                :key="item.idCountry"
                                :label="item.country"
                                :value="item.idCountry"
                              >
                              </el-option>
                            </el-select>
                          </el-col>
                          <el-col
                            :span="1"
                            v-if="
                              provider.generalData &&
                              provider.logCompanyGeneralData &&
                              provider.generalData.idCountry !=
                                provider.logCompanyGeneralData.idCountry
                            "
                          >
                            <el-tooltip placement="top">
                              <div slot="content">
                                Campo
                                <!--<br/>-->modificado
                              </div>
                              <i class="el-icon-info"></i>
                              <!--<i class="el-icon-time"></i>-->
                              <!--<el-alert
                                  type="info"
                                  show-icon
                                  center
                                  style="height: 40px"
                                  :closable="false">
                                </el-alert>-->
                              <!--<el-tag type="warning">Modificado</el-tag>-->
                            </el-tooltip>
                          </el-col>
                        </el-form-item>
                      </el-form-item>

                      <el-form-item label="Provincia" prop="idProvince">
                        <el-col :span="25" style="padding-right: 20px">
                          <el-select
                            id="state"
                            :disabled="generalData.idCountry === '' || !editing"
                            filterable
                            clearable
                            v-model="generalData.idProvince"
                          >
                            <el-option
                              v-for="item in provinces"
                              :key="item.idProvince"
                              :label="item.province"
                              :value="item.idProvince"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col
                          :span="1"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.idProvince !=
                            provider.logCompanyGeneralData.idProvince
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>

                      <el-form-item label="Ciudad" prop="city">
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.city"
                            :disabled="!editing"
                            maxlength="100"
                          ></el-input>
                        </el-col>
                        <span v-if="provider.generalData">
                          <el-col
                            :span="1"
                            style="padding-left: 20px"
                            v-if="
                              provider.logCompanyGeneralData &&
                              provider.generalData.city !=
                                provider.logCompanyGeneralData.city
                            "
                          >
                            <el-tooltip placement="top">
                              <div slot="content">
                                Campo
                                <!--<br/>-->modificado
                              </div>
                              <i class="el-icon-info"></i>
                              <!--<i class="el-icon-time"></i>-->
                              <!--<el-alert
                                type="info"
                                show-icon
                                center
                                style="height: 40px"
                                :closable="false">
                              </el-alert>-->
                              <!--<el-tag type="warning">Modificado</el-tag>-->
                            </el-tooltip>
                          </el-col>
                        </span>
                      </el-form-item>

                      <el-form-item
                        label="E-mail aviso de Pago"
                        prop="paymentEmail"
                      >
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.paymentEmail"
                            :disabled="!editing"
                            maxlength="100"
                          ></el-input>
                        </el-col>
                        <el-col
                          :span="1"
                          style="padding-left: 20px"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.paymentEmail !=
                              provider.logCompanyGeneralData.paymentEmail
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        label="E-mail aviso de Recepción"
                        prop="receiptEmail"
                      >
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.receiptEmail"
                            :disabled="!editing"
                            maxlength="100"
                          ></el-input>
                        </el-col>
                        <el-col
                          :span="1"
                          style="padding-left: 20px"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.receiptEmail !=
                              provider.logCompanyGeneralData.receiptEmail
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>

                      <el-form-item label="Sujeto IVA" prop="typeIVA">
                        <el-form-item>
                          <el-col :span="25" style="padding-right: 20px">
                            <el-select
                              id="sujeto"
                              filterable
                              clearable
                              v-model="generalData.typeIVA"
                              :disabled="!editing"
                            >
                              <!--<el-option label="Inscripto" value="Inscripto"></el-option>
                              <el-option label="Exento" value="Exento"></el-option>
                              <el-option label="Monotributo de Bienes" value="MonotributoB"></el-option>
                              <el-option label="Monotributo de Servicios" value="MonotributoS"></el-option>-->
                              <el-option
                                label="IVA Responsable Inscripto"
                                value="01"
                              ></el-option>
                              <el-option
                                label="IVA Responsable no Inscripto"
                                value="02"
                              ></el-option>
                              <el-option
                                label="IVA No Responsable"
                                value="03"
                              ></el-option>
                              <el-option
                                label="IVA Sujeto a exención"
                                value="04"
                              ></el-option>
                              <el-option
                                label="IVA consumidor final"
                                value="05"
                              ></el-option>
                              <el-option
                                label="Responsable Monotributo Bienes"
                                value="06"
                              ></el-option>
                              <el-option
                                label="Responsable Monotributo Servicios"
                                value="006"
                              ></el-option>
                              <el-option
                                label="Sujeto no Categorizado"
                                value="07"
                              ></el-option>
                              <el-option
                                label="Proveedor del exterior"
                                value="08"
                              ></el-option>
                            </el-select>
                          </el-col>
                          <el-col
                            :span="1"
                            v-if="
                              provider.generalData &&
                              provider.logCompanyGeneralData &&
                              provider.generalData.typeIVA !=
                                provider.logCompanyGeneralData.typeIVA
                            "
                          >
                            <el-tooltip placement="top">
                              <div slot="content">
                                Campo
                                <!--<br/>-->modificado
                              </div>
                              <i class="el-icon-info"></i>
                              <!--<i class="el-icon-time"></i>-->
                              <!--<el-alert
                                type="info"
                                show-icon
                                center
                                style="height: 40px"
                                :closable="false">
                              </el-alert>-->
                              <!--<el-tag type="warning">Modificado</el-tag>-->
                            </el-tooltip>
                          </el-col>
                        </el-form-item>
                      </el-form-item>

                      <el-form-item label="Persona" prop="personType">
                        <el-form-item>
                          <el-col :span="25" style="padding-right: 20px">
                            <el-select
                              id="persona"
                              filterable
                              clearable
                              v-model="generalData.personType"
                              @change="generalData.personSubType = ''"
                              :disabled="!editing"
                            >
                              <el-option
                                label="Física"
                                value="Física"
                              ></el-option>
                              <el-option
                                label="Jurídica"
                                value="Jurídica"
                              ></el-option>
                            </el-select>
                          </el-col>
                          <el-col
                            :span="1"
                            v-if="
                              provider.generalData &&
                              provider.logCompanyGeneralData &&
                              provider.generalData.personType !=
                                provider.logCompanyGeneralData.personType
                            "
                          >
                            <el-tooltip placement="top">
                              <div slot="content">
                                Campo
                                <!--<br/>-->modificado
                              </div>
                              <i class="el-icon-info"></i>
                              <!--<i class="el-icon-time"></i>-->
                              <!--<el-alert
                                type="info"
                                show-icon
                                center
                                style="height: 40px"
                                :closable="false">
                              </el-alert>-->
                              <!--<el-tag type="warning">Modificado</el-tag>-->
                            </el-tooltip>
                          </el-col>
                        </el-form-item>
                      </el-form-item>
                      <el-form-item
                        v-if="generalData.personType === 'Jurídica'"
                        label="Subtipo"
                        prop="personSubType"
                      >
                        <el-form-item>
                          <el-col :span="25" style="padding-right: 20px">
                            <el-select
                              filterable
                              clearable
                              v-model="generalData.personSubType"
                              :disabled="!editing"
                              @change="generalData.personSubTypeOther = ''"
                            >
                              <el-option label="S.A." value="S.A."></el-option>
                              <el-option
                                label="S.R.L."
                                value="S.R.L."
                              ></el-option>
                              <el-option label="S.H." value="S.H."></el-option>
                              <el-option label="Otro" value="Otro"></el-option>
                            </el-select>
                          </el-col>
                          <el-col
                            :span="1"
                            v-if="
                              provider.generalData &&
                              provider.logCompanyGeneralData &&
                              provider.generalData.personSubType !=
                                provider.logCompanyGeneralData.personSubType
                            "
                          >
                            <el-tooltip placement="top">
                              <div slot="content">
                                Campo
                                <!--<br/>-->modificado
                              </div>
                              <i class="el-icon-info"></i>
                              <!--<i class="el-icon-time"></i>-->
                              <!--<el-alert
                                  type="info"
                                  show-icon
                                  center
                                  style="height: 40px"
                                  :closable="false">
                                </el-alert>-->
                              <!--<el-tag type="warning">Modificado</el-tag>-->
                            </el-tooltip>
                          </el-col>
                        </el-form-item>
                      </el-form-item>
                      <el-form-item v-if="generalData.personSubType === 'Otro'">
                        <el-form-item
                          label="Otro subtipo"
                          prop="personSubTypeOther"
                        >
                          <el-form-item>
                            <el-col :span="23" style="padding-right: 20px">
                              <el-input
                                type="text"
                                v-model="generalData.personSubTypeOther"
                                :disabled="!editing"
                                maxlength="100"
                              ></el-input>
                            </el-col>
                            <el-col
                              :span="1"
                              style="padding-left: 20px"
                              v-if="
                                provider.generalData &&
                                provider.logCompanyGeneralData &&
                                provider.generalData.personSubTypeOther !=
                                  provider.logCompanyGeneralData
                                    .personSubTypeOther
                              "
                            >
                              <el-tooltip placement="top">
                                <div slot="content">
                                  Campo
                                  <!--<br/>-->modificado
                                </div>
                                <i class="el-icon-info"></i>
                                <!--<i class="el-icon-time"></i>-->
                                <!--<el-alert
                                type="info"
                                show-icon
                                center
                                style="height: 40px"
                                :closable="false">
                              </el-alert>-->
                                <!--<el-tag type="warning">Modificado</el-tag>-->
                              </el-tooltip>
                            </el-col>
                          </el-form-item>
                        </el-form-item>
                      </el-form-item>
                      <pdf-file
                        v-bind:pdfFilePath.sync="generalData.pdfAfip"
                        :habModificaPdf="editing"
                        titulo="* Alta de AFIP actualizada a la fecha"
                        id="altadeAfip"
                        prop="pdfAfip"
                      />

                      <br />
                      <el-divider content-position="left"
                        >Contacto principal</el-divider
                      >

                      <el-form-item label="Nombre" prop="namePrincipalContact">
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.namePrincipalContact"
                            :disabled="!editing"
                            maxlength="100"
                          ></el-input>
                        </el-col>
                        <el-col
                          :span="1"
                          style="padding-left: 20px"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.namePrincipalContact !=
                              provider.logCompanyGeneralData
                                .namePrincipalContact
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        label="Apellido"
                        prop="surnamePrincipalContact"
                      >
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.surnamePrincipalContact"
                            :disabled="!editing"
                            maxlength="100"
                          ></el-input>
                        </el-col>
                        <el-col
                          :span="1"
                          style="padding-left: 20px"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.surnamePrincipalContact !=
                              provider.logCompanyGeneralData
                                .surnamePrincipalContact
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        label="Teléfono"
                        prop="phonePrincipalContact"
                      >
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.phonePrincipalContact"
                            :disabled="!editing"
                            maxlength="100"
                          ></el-input>
                        </el-col>
                        <el-col
                          :span="1"
                          style="padding-left: 20px"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.phonePrincipalContact !=
                              provider.logCompanyGeneralData
                                .phonePrincipalContact
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>

                      <el-form-item label="E-mail" prop="emailPrincipalContact">
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.emailPrincipalContact"
                            :disabled="!editing"
                            maxlength="100"
                          ></el-input>
                        </el-col>
                        <el-col
                          :span="1"
                          style="padding-left: 20px"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.emailPrincipalContact !=
                              provider.logCompanyGeneralData
                                .emailPrincipalContact
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>

                      <el-divider></el-divider>
                      <br />
                      <el-divider content-position="left"
                        >Contacto comercial</el-divider
                      >

                      <el-form-item label="Nombre" prop="nameCommercialContact">
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.nameCommercialContact"
                            :disabled="!editing"
                            maxlength="100"
                          ></el-input>
                        </el-col>
                        <el-col
                          :span="1"
                          style="padding-left: 20px"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.nameCommercialContact !=
                              provider.logCompanyGeneralData
                                .nameCommercialContact
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        label="Apellido"
                        prop="surnameCommercialContact"
                      >
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.surnameCommercialContact"
                            maxlength="100"
                            :disabled="!editing"
                          ></el-input>
                        </el-col>
                        <el-col
                          :span="1"
                          style="padding-left: 20px"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.surnameCommercialContact !=
                              provider.logCompanyGeneralData
                                .surnameCommercialContact
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        label="Teléfono"
                        prop="phoneCommercialContact"
                      >
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.phoneCommercialContact"
                            :disabled="!editing"
                            maxlength="100"
                          ></el-input>
                        </el-col>
                        <el-col
                          :span="1"
                          style="padding-left: 20px"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.phoneCommercialContact !=
                              provider.logCompanyGeneralData
                                .phoneCommercialContact
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>

                      <el-form-item
                        label="E-mail"
                        prop="emailCommercialContact"
                      >
                        <el-col :span="23" style="padding-right: 20px">
                          <el-input
                            type="text"
                            v-model="generalData.emailCommercialContact"
                            :disabled="!editing"
                            maxlength="100"
                          ></el-input>
                        </el-col>
                        <el-col
                          :span="1"
                          style="padding-left: 20px"
                          v-if="
                            provider.generalData &&
                            provider.logCompanyGeneralData &&
                            provider.generalData.emailCommercialContact !=
                              provider.logCompanyGeneralData
                                .emailCommercialContact
                          "
                        >
                          <el-tooltip placement="top">
                            <div slot="content">
                              Campo
                              <!--<br/>-->modificado
                            </div>
                            <i class="el-icon-info"></i>
                            <!--<i class="el-icon-time"></i>-->
                            <!--<el-alert
                              type="info"
                              show-icon
                              center
                              style="height: 40px"
                              :closable="false">
                            </el-alert>-->
                            <!--<el-tag type="warning">Modificado</el-tag>-->
                          </el-tooltip>
                        </el-col>
                      </el-form-item>
                      <el-divider></el-divider>
                      <br />
                      <!--
                      <el-form-item label="Empresas de Grupo Albanesi" prop="idGroupCompany">
                        <el-select filterable clearable v-model="generalData.idGroupCompany">
                          <el-option
                            v-for="item in groupCompanies"
                            :key="item.idGroupCompany"
                            :label="item.groupCompany"
                            :value="item.idGroupCompany">
                          </el-option>
                        </el-select>
                      </el-form-item>
                      -->
                    </div>
                  </transition>
                </el-form>

                <el-form
                  v-if="step === 1"
                  :model="paymentData"
                  ref="paymentDataForm"
                  :disabled="false"
                  :rules="rulesPaymentData"
                  label-position="left"
                  label-width="25%"
                  id="formDatosPagos"
                  @submit.native.prevent=""
                >
                  <div v-if="false">
                    <el-divider>Cheque</el-divider>

                    <el-form-item
                      label="Sucursal de retiro"
                      prop="idBankBranch"
                    >
                      <el-col :span="25" style="padding-right: 20px">
                        <el-select
                          filterable
                          clearable
                          v-model="paymentData.idBankBranch"
                        >
                          <el-option
                            v-for="item in bankBranches"
                            :key="item.idBankBranch"
                            :label="item.bankBranch"
                            :value="item.idBankBranch"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col
                        :span="1"
                        v-if="
                          provider.paymentData &&
                          provider.logCompanyPaymentData &&
                          provider.paymentData.idBankBranch !=
                            provider.logCompanyPaymentData.idBankBranch
                        "
                      >
                        <el-tooltip placement="top">
                          <div slot="content">Campo modificado</div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </el-col>
                    </el-form-item>
                  </div>
                  <h5>
                    Fecha de creación: {{ provider.creationDate }}
                  </h5>
                  <el-divider>Transferencia</el-divider>

                  <el-form-item label="Banco" prop="idBank">
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        id="bank"
                        filterable
                        clearable
                        v-model="paymentData.idBank"
                        :disabled="!editing"
                      >
                        <el-option
                          v-for="item in banks"
                          :key="item.idBank"
                          :label="item.bank"
                          :value="item.idBank"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.paymentData &&
                        provider.logCompanyPaymentData &&
                        provider.paymentData.idBank !=
                          provider.logCompanyPaymentData.idBank
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="Tipo de cuenta" prop="idBankAccountType">
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        id="accounttype"
                        filterable
                        clearable
                        v-model="paymentData.idBankAccountType"
                        :disabled="!editing"
                      >
                        <el-option
                          v-for="item in accountTypes"
                          :key="item.idBankAccountType"
                          :label="item.bankAccountType"
                          :value="item.idBankAccountType"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.paymentData &&
                        provider.logCompanyPaymentData &&
                        provider.paymentData.idBankAccountType !=
                          provider.logCompanyPaymentData.idBankAccountType
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>

                  <el-form-item label="Nro. de cuenta" prop="accountNumber">
                    <el-col :span="15" style="padding-right: 20px">
                      <el-input
                        type="text"
                        id="accountnumber"
                        v-model="paymentData.accountNumber"
                        maxlength="50"
                        :disabled="!editing"
                      ></el-input>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.paymentData &&
                        provider.logCompanyPaymentData &&
                        provider.paymentData.accountNumber !=
                          provider.logCompanyPaymentData.accountNumber
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="Nro. CBU" prop="cbu">
                    <el-col :span="15" style="padding-right: 20px">
                      <el-input
                        type="text"
                        id="nrocbu"
                        v-model="paymentData.cbu"
                        maxlength="22"
                        show-word-limit
                        :disabled="!editing"
                      ></el-input>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.paymentData &&
                        provider.logCompanyPaymentData &&
                        provider.paymentData.cbu !=
                          provider.logCompanyPaymentData.cbu
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                  <pdf-file
                    v-bind:pdfFilePath.sync="paymentData.pdfBank"
                    :habModificaPdf="editing"
                    titulo="* Constancia"
                    id="formPdfBank"
                    prop="pdfBank"
                  />
                </el-form>

                <el-form
                  v-if="step === 2"
                  :model="taxData"
                  ref="taxDataForm"
                  :disabled="disabledData"
                  :rules="rulesTaxData"
                  label-position="left"
                  label-width="25%"
                  id="formDatosImpositivosIb"
                  @submit.native.prevent=""
                >
                  <h5>
                    Fecha de creación: {{ provider.creationDate }}
                  </h5>
                  <el-divider>Ingresos Brutos</el-divider>
                  <pdf-file
                    v-bind:pdfFilePath.sync="taxData.pdfIb"
                    :habModificaPdf="editing"
                    titulo="* Constancia IB actualizada a la fecha"
                    id="formIB"
                    prop="pdfIb"
                  />

                  <el-form-item label="Tipo" prop="ibType">
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        id="typeib"
                        clearable
                        v-model="taxData.ibType"
                        v-on:change="handleIbType"
                        :disabled="!editing"
                      >
                        <el-option
                          label="Multilateral"
                          value="Multilateral"
                        ></el-option>
                        <el-option label="Local" value="Local"></el-option>
                        <el-option label="Exento" value="Exento"></el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.ibType !=
                          provider.logCompanyTaxData.ibType
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>

                  <pdf-file
                    v-if="taxData.ibType === 'Exento'"
                    v-bind:pdfFilePath.sync="taxData.pdfsExempt"
                    :habModificaPdf="editing"
                    titulo="* Constancia de exento"
                    id="uploadConstanciaExcento"
                    prop="pdfExempt"
                  />

                  <el-form-item
                    label="Regimen de convenio"
                    v-if="taxData.ibType === 'Multilateral'"
                    prop="idAgreementRegimeType"
                  >
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        id="regimenConvenio"
                        filterable
                        clearable
                        v-model="taxData.idAgreementRegimeType"
                        :disabled="!editing"
                      >
                        <el-option
                          v-for="item in regimenTypes"
                          :key="item.idAgreementRegimeType"
                          :label="item.agreementRegimeType"
                          :value="item.idAgreementRegimeType"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.idAgreementRegimeType !=
                          provider.logCompanyTaxData.idAgreementRegimeType
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                  <pdf-file
                    v-if="taxData.ibType === 'Multilateral'"
                    v-bind:pdfFilePath.sync="taxData.pdfCM05"
                    :habModificaPdf="editing"
                    titulo="* CM05"
                    id="uploadPdfCM05"
                    prop="pdfCM05"
                  />
                  <el-form-item
                    v-if="jurisdicciones"
                    label="Jurisdicción sede"
                    prop="jurisdictionHeadquarters"
                  >
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        id="jsede"
                        filterable
                        clearable
                        v-model="taxData.jurisdictionHeadquarters"
                        :disabled="!editing"
                      >
                        <el-option
                          v-for="item in jurisdictions"
                          :key="item.idJurisdictions"
                          :label="item.jurisdictions"
                          :value="item.idJurisdictions"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.jurisdictionHeadquarters !=
                          provider.logCompanyTaxData.jurisdictionHeadquarters
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>

                  <el-form-item label-width="0" prop="jurisdictions">
                    <el-row
                      align="center"
                      type="flex"
                      style="text-align: center"
                      justify="center"
                      :gutter="10"
                    >
                      <el-col
                        :span="6"
                        v-if="this.doc1276 === false"
                        style="padding-right: 45px"
                      >
                        Jurisdicción
                      </el-col>
                      <el-col :span="5" v-if="this.doc1276 === true">
                        Jurisdicción
                      </el-col>
                      <el-col :span="8"> Alicuota** </el-col>
                      <el-col
                        v-if="this.doc1276 === false"
                        :span="4"
                        style="padding-right: 45px"
                      >
                        Coef. Unificado
                      </el-col>
                      <el-col
                        v-if="this.doc1276 === true"
                        :span="5"
                        style="padding-right: 1%"
                      >
                        Coef. Unificado
                      </el-col>
                      <el-col
                        v-if="this.doc1276 === false"
                        :span="4"
                        style="margin-right: 60px"
                      >
                        N° de Certificado
                      </el-col>
                      <el-col
                        v-if="this.doc1276 === true"
                        :span="3"
                        style="margin-right: 40px"
                      >
                        N° de Certificado
                      </el-col>
                      <el-col
                        v-if="this.doc1276 === false"
                        :span="4"
                        style="margin-left: -50px"
                      >
                        Datos adicionales
                      </el-col>
                      <el-col
                        v-if="this.doc1276 === true"
                        :span="6"
                        style="padding-left: 10px"
                      >
                        Datos adicionales
                      </el-col>
                      <el-col v-if="this.doc1276 === false" :span="6" style="">
                        Agente de Retención
                      </el-col>
                      <el-col
                        v-if="this.doc1276 === true"
                        :span="3"
                        style="padding-left: 45px; line-height: 30px"
                      >
                        Agente de Retención
                      </el-col>
                      <el-col v-if="this.doc1276 === false" :span="3" style="">
                        Agente de Percepción
                      </el-col>
                      <el-col
                        v-if="this.doc1276 === true"
                        :span="2"
                        style="padding-left: 50px; line-height: 30px"
                      >
                        Agente de Percepción
                      </el-col>
                      <el-col
                        v-if="this.doc1276 === true"
                        :span="3"
                        style="padding-left: 80px"
                      >
                        <span style="color: red">*</span>Formulario 1276
                      </el-col>
                      <el-col :span="1"> </el-col>
                      <el-col :span="1"> </el-col>
                    </el-row>

                    <el-row
                      v-for="(jurisdict, jurId) in taxData.jurisdictions"
                      :key="jurId"
                      align="center"
                      type="flex"
                      style="text-align: center; margin-bottom: 15px"
                      justify="center"
                      :gutter="5"
                    >
                      <el-col :span="6">
                        <el-form-item
                          prop="'jurisdictions\[' + jurId + '\]\[\'idJurisdiction\'\]'"
                        >
                          <el-select
                            style="width: 95%"
                            filterable
                            clearable
                            v-model="jurisdict.idJurisdiction"
                            @change="
                              updateAliquot(
                                jurisdict.idJurisdiction,
                                jurId
                              )
                            "
                            :disabled="!editing"
                          >
                            <el-option
                              v-for="item in jurisdictionsHabilitadas"
                              :key="item.idJurisdictions"
                              :label="item.jurisdictions"
                              :value="item.idJurisdictions"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <!-- cod alicuota -->
                      <el-col :span="4">
                        <el-form-item
                          v-if="!isAlicuotList(jurisdict.idJurisdiction, jurId)"
                          prop="'jurisdictions\[' + jurId + '\]\[\'aliquot\'\]'"
                          :rules="[
                            {
                              required: isSantaFe(jurisdict.idJurisdiction),
                              message: 'Campo obligatorio',
                              trigger: 'change',
                            },
                            { trigger: 'change' },
                          ]"
                        >
                          <el-input
                            type="number"
                            v-model.number="jurisdict.aliquota_value"
                            :disabled="!editing"
                            ></el-input>
                        </el-form-item>

                        <el-form-item
                          v-if="isAlicuotList(jurisdict.idJurisdiction, jurId)"
                          prop="'jurisdictions\[' + jurId + '\]\[\'aliquot\'\]'"
                          :rules="[
                            {
                              required: isSantaFe(jurisdict.idJurisdiction),
                              message: 'Campo obligatorio',
                              trigger: 'change',
                            },
                            { trigger: 'change' },
                          ]"
                        >
                          <el-select
                            style="width: 100%"
                            filterable
                            clearable
                            v-model="jurisdict.aliquot"
                            :disabled="!editing"
                          >
                            <el-option
                              v-for="item in retentionCategoriesAliquot[jurId]"
                              :key="item.idCategoryRetain"
                              :label="item.categoryRetain"
                              :value="item.idCategoryRetain"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <!-- porcentage -->
                      <el-col :span="3">
                        <el-form-item
                          :prop="
                            'jurisdictions\[' + jurId + '\]\[\'coefficient\'\]'
                          "
                        >
                          <el-input
                            v-model="jurisdict.coefficient"
                            :disabled="!editing"
                            @input="validateCoefficient($event, jurId)">
                          </el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="5">
                        <el-form-item
                          :prop="
                            'jurisdictions\[' +
                            jurId +
                            '\]\[\'certificateNumber\'\]'
                          "
                        >
                          <el-input
                            v-model="jurisdict.certificateNumber"
                            :disabled="!editing"
                          ></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-button
                          type="primary"
                          :disabled="!jurisdict.certificateNumber && !editing"
                          @click="openModalCertificateDetails(jurId)"
                        >
                          Editar
                        </el-button>
                        <el-dialog
                          title="Datos adicionales del certificado"
                          :visible="jurisdict.certficateDetailsVisible"
                          width="40%"
                        >
                          <div v-show="false">
                            <el-form-item
                              label="Desde"
                              :prop="
                                'jurisdictions\[' +
                                jurId +
                                '\]\[\'certificateFrom\'\]'
                              "
                              :rules="[
                                {
                                  required: true,
                                  message: 'Campo obligatorio',
                                  trigger: 'change',
                                },
                              ]"
                            >
                              <el-date-picker
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                                v-model="jurisdict.certificateFrom"
                                type="date"
                                placeholder="Seleccionar"
                              >
                              </el-date-picker>
                            </el-form-item>
                            <el-form-item
                              label="Hasta"
                              :prop="
                                'jurisdictions\[' +
                                jurId +
                                '\]\[\'certificateTo\'\]'
                              "
                              :rules="[
                                {
                                  required: true,
                                  message: 'Campo obligatorio',
                                  trigger: 'change',
                                },
                              ]"
                            >
                              <el-date-picker
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                                v-model="jurisdict.certificateTo"
                                type="date"
                                placeholder="Seleccionar"
                              >
                              </el-date-picker>
                            </el-form-item>

                            <el-form-item
                              label="Constancia"
                              :prop="
                                'jurisdictions\[' +
                                jurId +
                                '\]\[\'certificatePdf\'\]'
                              "
                              :rules="[
                                {
                                  required: true,
                                  message: 'Campo obligatorio',
                                  trigger: 'change',
                                },
                              ]"
                            >
                              <el-upload
                                v-if="habModificaPdf"
                                class="upload-demo"
                                :ref="
                                  'jurisdictions\[' +
                                  jurId +
                                  '\]\[\'certificatePdf\'\]'
                                "
                                :action="serverURI + 'api/uploadFile'"
                                :auto-upload="true"
                                accept="application/pdf"
                                :on-success="handlePdfCertificate"
                                :on-exceed="handleExceed"
                                :data="{
                                  folder: 'altaProveedor',
                                }"
                                :limit="1"
                              >
                                <el-button
                                  slot="trigger"
                                  size="small"
                                  type="primary"
                                  >Seleccionar archivo</el-button
                                >
                                <div slot="tip" class="el-upload__tip">
                                  Solo se permiten archivos PDF
                                </div>
                              </el-upload>
                              <span v-else>
                                <a
                                  v-if="jurisdict.certificatePdf"
                                  :href="jurisdict.certificatePdf"
                                  target="_blank"
                                  style="padding-right: 20px"
                                >
                                  <i class="fa fa-file-pdf-o" /> Ver
                                </a>
                                <span v-else> - </span>
                              </span>
                            </el-form-item>
                            <span slot="footer" class="dialog-footer">
                              <el-button
                                type="primary"
                                @click="
                                  jurisdict.certficateDetailsVisible = false
                                "
                                >Confirmar</el-button
                              >
                            </span>
                          </div>
                        </el-dialog>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item
                          :prop="
                            'jurisdictions\[' +
                            jurId +
                            '\]\[\'retentionAgentHas\'\]'
                          "
                        >
                          <el-switch
                            v-model="jurisdict.retentionAgentHas"
                            active-text="Si"
                            inactive-text="No"
                            active-value="1"
                            inactive-value="0"
                            @change="openModalRetentionAgent(jurId)"
                            :disabled="!editing"
                          >
                          </el-switch>
                          <el-button
                            type="success"
                            v-if="jurisdict.retentionAgentHas === '1'"
                            size="small"
                            circle
                            icon="el-icon-edit"
                            style="margin-left: 5px"
                            @click="openModalRetentionAgent(jurId)"
                          ></el-button>
                          <el-form-item
                            v-if="jurisdict.retentionAgentHas === '1'"
                            label=""
                            label-width="0"
                            :prop="
                              'jurisdictions\[' +
                              jurId +
                              '\]\[\'retentionAgentPdf\'\]'
                            "
                          >
                          </el-form-item>
                          <el-form-item
                            v-if="jurisdict.retentionAgentHas === '1'"
                            label=""
                            label-width="0"
                            :prop="
                              'jurisdictions\[' +
                              jurId +
                              '\]\[\'retentionAgentDate\'\]'
                            "
                          >
                          </el-form-item>

                          <el-dialog
                            v-if="jurisdict.retentionAgentHas === '1'"
                            title="Agente de retención."
                            :visible="jurisdict.retentionAgentVisible"
                            width="40%"
                            :before-close="
                              () => (jurisdict.retentionAgentHas = '0')
                            "
                          >
                            <el-form-item
                              label="Fecha de alta"
                              :prop="
                                'jurisdictions\[' +
                                jurId +
                                '\]\[\'retentionAgentDate\'\]'
                              "
                            >
                              <el-date-picker
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                                v-model="jurisdict.retentionAgentDate"
                                type="date"
                                placeholder="Seleccionar"
                              >
                              </el-date-picker>
                            </el-form-item>
                            <el-form-item
                              label="Constancia"
                              :prop="
                                'jurisdictions\[' +
                                jurId +
                                '\]\[\'retentionAgentPdf\'\]'
                              "
                            >
                              <el-upload
                                v-if="habModificaPdf"
                                class="upload-demo"
                                :ref="
                                  'jurisdictions\[' +
                                  jurId +
                                  '\]\[\'retentionAgentPdf\'\]'
                                "
                                :action="serverURI + 'api/uploadFile'"
                                :auto-upload="true"
                                accept="application/pdf"
                                :on-success="handlePdfRetentionAgent"
                                :on-exceed="handleExceed"
                                :data="{
                                  folder: 'altaProveedor',
                                }"
                                :limit="1"
                              >
                                <el-button
                                  slot="trigger"
                                  size="small"
                                  type="primary"
                                  >Seleccionar archivo</el-button
                                >
                                <div slot="tip" class="el-upload__tip">
                                  Solo se permiten archivos PDF
                                </div>
                              </el-upload>
                              <span v-else>
                                <a
                                  v-if="jurisdict.retentionAgentPdf"
                                  :href="jurisdict.retentionAgentPdf"
                                  target="_blank"
                                  style="padding-right: 20px"
                                >
                                  <i class="fa fa-file-pdf-o" /> Ver
                                </a>
                                <span v-else> - </span>
                              </span>
                            </el-form-item>
                            <span slot="footer" class="dialog-footer">
                              <el-button
                                type="primary"
                                @click="jurisdict.retentionAgentVisible = false"
                                >Confirmar</el-button
                              >
                            </span>
                          </el-dialog>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item
                          :prop="
                            'jurisdictions\[' +
                            jurId +
                            '\]\[\'perceptionAgentHas\'\]'
                          "
                        >
                          <el-col :span="25" style="padding-right: 20px">
                            <el-switch
                              v-model="jurisdict.perceptionAgentHas"
                              active-text="Si"
                              inactive-text="No"
                              active-value="1"
                              inactive-value="0"
                              @change="openModalPerceptionAgent(jurId)"
                            :disabled="!editing"
                            >
                            </el-switch>
                          </el-col>
                          <!-- <el-col :span="1" v-if="provider.taxData.LogCompanyJurisdictionData && provider.logCompanyTaxData.LogCompanyJurisdictionData && (provider.taxData.jurisdictions[0].aliquot != provider.logCompanyTaxData.LogCompanyJurisdictionData[0].aliquot)">
                                  <el-tooltip placement="top">
                                    <div slot="content">Campo modificado</div>
                                    <i class="el-icon-info"></i>
                                  </el-tooltip>
                                </el-col> -->

                          <el-button
                            type="success"
                            v-if="jurisdict.perceptionAgentHas === '1'"
                            size="small"
                            circle
                            icon="el-icon-edit"
                            style="margin-left: 5px"
                            @click="openModalPerceptionAgent(jurId)"
                          ></el-button>
                          <el-form-item
                            v-if="jurisdict.perceptionAgentHas === '1'"
                            label=""
                            label-width="0"
                            :prop="
                              'jurisdictions\[' +
                              jurId +
                              '\]\[\'retentionAgentPdf\'\]'
                            "
                          >
                          </el-form-item>
                          <el-form-item
                            v-if="jurisdict.perceptionAgentHas === '1'"
                            label=""
                            label-width="0"
                            :prop="
                              'jurisdictions\[' +
                              jurId +
                              '\]\[\'perceptionAgentDate\'\]'
                            "
                          >
                          </el-form-item>

                          <el-dialog
                            v-if="jurisdict.perceptionAgentHas === '1'"
                            title="Agente de percepción."
                            :visible="jurisdict.perceptionAgentVisible"
                            width="40%"
                            :before-close="
                              () => (jurisdict.perceptionAgentHas = '0')
                            "
                          >
                            <el-form-item
                              label="Fecha de alta"
                              :prop="
                                'jurisdictions\[' +
                                jurId +
                                '\]\[\'perceptionAgentDate\'\]'
                              "
                            >
                              <el-date-picker
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                                v-model="jurisdict.perceptionAgentDate"
                                type="date"
                                placeholder="Seleccionar"
                              >
                              </el-date-picker>
                            </el-form-item>
                            <el-form-item
                              label="Constancia"
                              :prop="
                                'jurisdictions\[' +
                                jurId +
                                '\]\[\'perceptionAgentPdf\'\]'
                              "
                            >
                              <el-upload
                                v-if="habModificaPdf"
                                class="upload-demo"
                                :ref="
                                  'jurisdictions\[' +
                                  jurId +
                                  '\]\[\'perceptionAgentPdf\'\]'
                                "
                                :action="serverURI + 'api/uploadFile'"
                                :auto-upload="true"
                                accept="application/pdf"
                                :on-success="handlePdfPerceptionAgent"
                                :on-exceed="handleExceed"
                                :data="{
                                  folder: 'altaProveedor',
                                }"
                                :limit="1"
                              >
                                <el-button
                                  slot="trigger"
                                  size="small"
                                  type="primary"
                                  >Seleccionar archivo</el-button
                                >
                                <div slot="tip" class="el-upload__tip">
                                  Solo se permiten archivos PDF
                                </div>
                              </el-upload>
                              <span v-else>
                                <a
                                  v-if="jurisdict.perceptionAgentPdf"
                                  :href="jurisdict.perceptionAgentPdf"
                                  target="_blank"
                                  style="padding-right: 20px"
                                >
                                  <i class="fa fa-file-pdf-o" /> Ver
                                </a>
                                <span v-else> - </span>
                              </span>
                            </el-form-item>
                            <span slot="footer" class="dialog-footer">
                              <el-button
                                type="primary"
                                @click="
                                  jurisdict.perceptionAgentVisible = false
                                "
                                >Confirmar</el-button
                              >
                            </span>
                          </el-dialog>
                        </el-form-item>
                      </el-col>
                      <el-col
                        :span="2"
                        v-if="jurisdict.idJurisdiction === '13'"
                      >
                        <el-form :disabledData="false">
                          <el-button
                            size="mini"
                            type="primary"
                            style="font-size: 10px"
                            @click="openModalForm1276(jurId)"
                            :disabled="!editing"
                          >
                            Seleccionar archivo
                          </el-button>
                        </el-form>
                      </el-col>
                      <el-form-item v-if="['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction)" style="width: 250px;margin-right: -250px;">  
                      <input
                          type="checkbox"
                          name="operaAqui"
                          :disabled="!editing"
                          required
                          style="width: 15px; float: left;cursor:pointer; margin-right: 25px;margin-top:13px"
                          v-model="jurisdict.agentDontOperateHere"
                        /><span style="margin-left:-80px;margin-top:15px;">No Presta Servicio aqui</span>
                      </el-form-item>
                      <el-col :span="3" style="margin-left:-75px" v-if="!['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction) && jurisdict.idJurisdiction !== '13'">
                        <el-button
                          type="warning"
                          size="small"
                          style="padding-left: 10px"
                          v-on:click="deleteJurisdiction(jurisdict)"
                          v-if="
                            ((taxData.ibType === 'Multilateral' && jurId > 1) ||
                              (taxData.ibType !== 'Multilateral' &&
                                jurId > 0)) &&
                            !provider
                          "
                          >X</el-button
                        >
                      </el-col>
                      <el-col :span="5" :offset="2" style="float:right;margin-right:-250px" v-if="['1', '2', '22', '14', '15'].includes(jurisdict.idJurisdiction)">
                        <el-button
                          type="warning"
                          size="small"
                          style="padding-left: 10px"
                          v-on:click="deleteJurisdiction(jurisdict)"
                          v-if="
                            ((taxData.ibType === 'Multilateral' && jurId > 1) ||
                              (taxData.ibType !== 'Multilateral' &&
                                jurId > 0)) &&
                            !provider
                          "
                          >X</el-button
                        >
                      </el-col>
                      <el-col :span="3" style="margin-left:-25px" v-if="jurisdict.idJurisdiction === '13'">
                        <el-button
                          type="warning"
                          size="small"
                          style="padding-left: 10px"
                          v-on:click="deleteJurisdiction(jurisdict)"
                          v-if="
                            ((taxData.ibType === 'Multilateral' && jurId > 1) ||
                              (taxData.ibType !== 'Multilateral' &&
                                jurId > 0)) &&
                            !provider
                          "
                          >X</el-button
                        >
                      </el-col>
                    </el-row>

                    <el-button
                      type="primary"
                      size="small"
                      v-on:click="addJurisdiction()"
                      v-if="taxData.ibType === 'Multilateral'"
                      :disabled="!editing"
                      >Agregar jurisdicción</el-button
                    >
                  </el-form-item>
                  <p>** Alicuota a aplicar por el agente de retención</p>
                  <el-divider>Retención Ganancias</el-divider>
                  <el-form-item label="Tipo" prop="earningsRetentionType">
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        id="typeGanancias"
                        filterable
                        clearable
                        v-model="taxData.earningsRetentionType"
                        :disabled="!editing"
                      >
                        <el-option
                          label="Inscripto"
                          value="Inscripto"
                        ></el-option>
                        <el-option label="Exento" value="Exento"></el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.earningsRetentionType !=
                          provider.logCompanyTaxData.earningsRetentionType
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>

                  <el-form-item
                    v-if="
                      taxData.earningsRetentionType === 'Inscripto' &&
                      generalData.typeIVA !== '06'
                    "
                    label="Régimen de Retención"
                    prop="retentionRegimen"
                  >
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        id="retencion"
                        filterable
                        clearable
                        v-model="taxData.retentionRegimen"
                        @change="updateRetentionCategory"
                        :disabled="!editing"
                      >
                        <el-option
                          v-for="item in retentionRegimes"
                          :key="item.idRetentionRegime"
                          :label="item.retentionRegime"
                          :value="item.idRetentionRegime"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.retentionRegimen !=
                          provider.logCompanyTaxData.retentionRegimen
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>

                  <el-form-item
                    v-if="
                      taxData.earningsRetentionType === 'Inscripto' &&
                      generalData.typeIVA === '06'
                    "
                    label="Régimen de Retención"
                    prop="retentionRegimen"
                  >
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        filterable
                        clearable
                        v-model="taxData.retentionRegimen"
                        @change="updateRetentionCategory"
                      >
                        <el-option
                          v-for="item in retentionRegimeList"
                          :key="item.idRetentionRegime"
                          :label="item.retentionRegime"
                          :value="item.idRetentionRegime"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.retentionRegimen !=
                          provider.logCompanyTaxData.retentionRegimen
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                  <!--{{this.retentionCategories2}}-->
                  <!--{{this.provider.taxData.retentionRegimen}}-->
                  <el-form-item
                    v-if="taxData.earningsRetentionType === 'Inscripto'"
                    label="Categoría a retener"
                    prop="idEarningCategoryRetain"
                  >
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        id="categoriaR"
                        filterable
                        clearable
                        v-model="taxData.idEarningCategoryRetain"
                        :disabled="!editing"
                      >
                        <el-option
                          v-for="item in retentionCategories2"
                          :key="item.idCategoryRetain"
                          :label="item.categoryRetain"
                          :value="item.idCategoryRetain"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.idEarningCategoryRetain !=
                          provider.logCompanyTaxData.idEarningCategoryRetain
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>

                  <!--<span v-if="provider && provider.certificationExgain.length > 0">-->
                  <!--{{this.certificationExgainList}}-->
                  <!--<span v-if="this.auxFlagEmptyExgainList === false || provider.certifExgain.length > 0">-->
                  <div v-if="this.user !== null">
                    <el-form :disabledData="false">
                      <span>Certificado de exclusión Retención Ganancias</span>
                      <span v-if="provider && provider.certifExgain.length > 0">
                        <el-button
                          size="mini"
                          type="primary"
                          plain
                          icon="el-icon-view"
                          @click="openCertificationExgainList()"
                          >Ver</el-button
                        >
                        <!--  <i class="fa fa-file-pdf-o"/> Ver -->
                      </span>
                      <!--<span v-if="this.auxFlagEmptyExgainList === true || provider.certifExgain.length < 0">-->
                      <span v-else>
                        <el-tag type="warning">No se encontró</el-tag>
                      </span>
                    </el-form>
                  </div>
                  <div v-if="this.user === null">
                    <el-form :disabledData="false">
                      <span>Certificado de exclusión Retención Ganancias</span>
                      <!--<span v-if="this.certifExgain && this.certifExgain.length > 0">-->
                      <span v-if="this.certificationExgainList.length > 0">
                        <el-button
                          size="mini"
                          type="primary"
                          plain
                          icon="el-icon-view"
                          @click="openCertificationExgainList()"
                          >Ver</el-button
                        >
                        <!--  <i class="fa fa-file-pdf-o"/> Ver -->
                      </span>
                      <!--<span v-if="this.auxFlagEmptyExgainList === true || provider.certifExgain.length < 0">-->
                      <span v-else>
                        <el-tag type="warning">No se encontró</el-tag>
                      </span>
                    </el-form>
                  </div>
                  <br /><br />
                  <div v-if="this.user !== null">
                    <el-form :disabledData="false">
                      <span>Certificado de exención RG2681</span>
                      <!--<span v-if="provider && provider.certifRg2681.length > 0">-->
                      <span v-if="provider && provider.certifRg2681.length > 0">
                        <el-button
                          size="mini"
                          type="primary"
                          plain
                          icon="el-icon-view"
                          @click="openCertificationRg2681List()"
                          >Ver</el-button
                        >
                        <!--  <i class="fa fa-file-pdf-o"/> Ver -->
                      </span>
                      <span v-else>
                        <el-tag type="warning">No se encontró</el-tag>
                      </span>
                      <br /><br />
                    </el-form>
                  </div>
                  <div v-if="this.user === null">
                    <el-form :disabledData="false">
                      <span>Certificado de exención RG2681</span>
                      <!--<span v-if="provider && provider.certifRg2681.length > 0">-->
                      <span v-if="this.certificationRg2681List.length > 0">
                        <el-button
                          size="mini"
                          type="primary"
                          plain
                          icon="el-icon-view"
                          @click="openCertificationRg2681List()"
                          >Ver</el-button
                        >
                        <!--  <i class="fa fa-file-pdf-o"/> Ver -->
                      </span>
                      <span v-else>
                        <el-tag type="warning">No se encontró</el-tag>
                      </span>
                      <br /><br />
                    </el-form>
                  </div>

                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item
                        :prop="'earningsExclusionNumber'"
                        label="Número"
                      >
                        <el-input
                          v-model="taxData.earningsExclusionNumber"
                          :disabled="!editing"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="taxData.earningsExclusionNumber">
                      <el-form-item
                        label-width="0px"
                        label=""
                        :prop="'earningsExclusionFrom'"
                      >
                        <el-date-picker
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          :disabled="!taxData.earningsExclusionNumber"
                          v-model="taxData.earningsExclusionFrom"
                          type="date"
                          placeholder="Desde"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="taxData.earningsExclusionNumber">
                      <el-form-item
                        label=""
                        label-width="0px"
                        :prop="'earningsExclusionTo'"
                      >
                        <el-date-picker
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          :disabled="!taxData.earningsExclusionNumber"
                          :picker-options="disabledDates"
                          v-model="taxData.earningsExclusionTo"
                          type="date"
                          placeholder="Hasta"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.earningsExclusionNumber !=
                          provider.logCompanyTaxData.earningsExclusionNumber
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">
                          Campo 'Número' <br />
                          modificado
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.earningsExclusionFrom !=
                          provider.logCompanyTaxData.earningsExclusionFrom
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">
                          Campo 'Fecha desde' <br />
                          modificado
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.earningsExclusionTo !=
                          provider.logCompanyTaxData.earningsExclusionTo
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">
                          Campo 'Fecha hasta' <br />
                          modificado
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="6" v-if="taxData.earningsExclusionNumber">
                      <pdf-file
                        v-bind:pdfFilePath.sync="taxData.earningsExclusionPdf"
                        :habModificaPdf="habModificaPdf"
                        titulo="* Certificado exclusión"
                        id="uploadPdfearningsExclusion"
                        prop="earningsExclusionPdf"
                      />
                    </el-col>
                    <el-col>
                      <div v-if="this.user !== null">
                        <span
                          v-if="provider && provider.certifExgain.length > 0"
                        >
                          <el-alert
                            title="Tiene un certificado de exclusión vigente, por favor completar lo que corresponda"
                            type="info"
                            :closable="false"
                          >
                          </el-alert>
                        </span>
                        <span v-else> </span>
                      </div>
                      <div v-if="this.user === null">
                        <span v-if="this.certificationExgainList.length > 0">
                          <el-alert
                            title="Tiene un certificado de exclusión vigente, por favor completar lo que corresponda"
                            type="info"
                            :closable="false"
                          >
                          </el-alert>
                        </span>
                        <span v-else> </span>
                      </div>
                    </el-col>
                    <el-col>
                      <div v-if="this.user !== null">
                        <span
                          v-if="provider && provider.certifRg2681.length > 0"
                        >
                          <el-alert
                            title="Tiene un certificado de exclusión vigente, por favor completar lo que corresponda"
                            type="info"
                            :closable="false"
                          >
                          </el-alert>
                        </span>
                        <span v-else> </span>
                      </div>
                      <div v-if="this.user === null">
                        <span v-if="this.certificationRg2681List.length > 0">
                          <el-alert
                            title="Tiene un certificado de exclusión vigente, por favor completar lo que corresponda"
                            type="info"
                            :closable="false"
                          >
                          </el-alert>
                        </span>
                        <span v-else> </span>
                      </div>
                    </el-col>
                  </el-row>
                  <el-divider>Retención SUSS</el-divider>
                  <el-form-item label="Empleador" :prop="'sussEmployeer'">
                    <el-col :span="25" style="padding-right: 20px">
                      <el-switch
                        v-model="taxData.sussEmployeer"
                        @change="
                          taxData.sussEmployeer
                            ? (taxData.sussRetentionRegimen =
                                taxData.sussEmployeer)
                            : taxData.sussEmployeer
                        "
                        active-text="Si"
                        inactive-text="No"
                        active-value="1"
                        inactive-value="0"
                        :disabled="!editing"
                      >
                      </el-switch>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.sussEmployeer !=
                          provider.logCompanyTaxData.sussEmployeer
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                  <el-form-item
                    label="Agente de retención"
                    :prop="'retentionRegime'"
                  >
                    <el-col :span="25" style="padding-right: 20px">
                      <el-switch
                        :disabled="taxData.sussEmployeer === '0' || !editing"
                        v-model="taxData.sussRetentionRegimen"
                        active-value="1"
                        inactive-value="0"
                        active-text="Si"
                        inactive-text="No"
                        @change="sussIdCategoryRetainClear()"

                      >
                      </el-switch>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.sussRetentionRegimen !=
                          provider.logCompanyTaxData.sussRetentionRegimen
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                  <el-form-item
                    label="Régimen a retener"
                    prop="sussIdCategoryRetain"
                    v-if="
                      taxData.sussEmployeer &&
                      taxData.sussRetentionRegimen === '1'
                    "
                  >
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        filterable
                        clearable
                        v-model="taxData.sussIdCategoryRetain"
                        :disabled="!editing"
                      >
                        <el-option
                          v-for="item in sussRetentionCategory"
                          :key="item.idCategoryRetain"
                          :label="item.categoryRetain"
                          :value="item.idCategoryRetain"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.sussIdCategoryRetain !=
                          provider.logCompanyTaxData.sussIdCategoryRetain
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                  <el-form-item
                    label="Régimen a retener"
                    prop="sussIdCategoryRetain"
                    v-if="
                      taxData.sussEmployeer == '1' &&
                      taxData.sussRetentionRegimen == '0'
                    "
                  >
                    <el-col :span="25" style="padding-right: 20px">
                      <el-select
                        filterable
                        clearable
                        v-model="taxData.sussIdCategoryRetain"
                      >
                        <el-option
                          v-for="item in sussRetentionCategory"
                          :key="item.idCategoryRetain"
                          :label="item.categoryRetain"
                          :value="item.idCategoryRetain"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.sussIdCategoryRetain !=
                          provider.logCompanyTaxData.sussIdCategoryRetain
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                  </el-form-item>
                  <div v-if="this.user !== null">
                    <el-form :disabledData="false">
                      <span>Certificado de exclusión</span>
                      <!--<span v-if="provider && provider.certifSuss.length > 0">-->
                      <span v-if="provider && provider.certifSuss.length > 0">
                        <el-button
                          size="mini"
                          type="primary"
                          plain
                          icon="el-icon-view"
                          @click="openCertificationSussList()"
                          >Ver</el-button
                        >
                        <!--  <i class="fa fa-file-pdf-o"/> Ver -->
                      </span>
                      <span v-else>
                        <el-tag type="warning">No se encontró</el-tag>
                      </span>
                    </el-form>
                  </div>
                  <div v-if="this.user === null">
                    <el-form :disabledData="false">
                      <span>Certificado de exclusión</span>
                      <!--<span v-if="provider && provider.certifSuss.length > 0">-->
                      <span v-if="this.certificationSussList.length > 0">
                        <el-button
                          size="mini"
                          type="primary"
                          plain
                          icon="el-icon-view"
                          @click="openCertificationSussList()"
                          >Ver</el-button
                        >
                        <!--  <i class="fa fa-file-pdf-o"/> Ver -->
                      </span>
                      <span v-else>
                        <el-tag type="warning">No se encontró</el-tag>
                      </span>
                    </el-form>
                  </div>
                  <br /><br />

                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item
                        :prop="'sussExclusionNumber'"
                        label="Número"
                      >
                        <el-input
                          v-model="taxData.sussExclusionNumber"
                          maxlength="30"
                          :disabled="!editing"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="taxData.sussExclusionNumber">
                      <el-form-item
                        label-width="0px"
                        label=""
                        :prop="'sussExclusionFrom'"
                      >
                        <el-date-picker
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          :disabled="!taxData.sussExclusionNumber"
                          v-model="taxData.sussExclusionFrom"
                          type="date"
                          placeholder="Desde"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="taxData.sussExclusionNumber">
                      <el-form-item
                        label=""
                        label-width="0px"
                        :prop="'sussExclusionTo'"
                      >
                        <el-date-picker
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          :picker-options="disabledDates"
                          :disabled="!taxData.sussExclusionNumber"
                          v-model="taxData.sussExclusionTo"
                          type="date"
                          placeholder="Hasta"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.sussExclusionNumber !=
                          provider.logCompanyTaxData.sussExclusionNumber
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">
                          Campo 'Número' <br />
                          modificado
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.sussExclusionFrom !=
                          provider.logCompanyTaxData.sussExclusionFrom
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">
                          Campo 'Fecha desde' <br />
                          modificado
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.earningsExclusionTo !=
                          provider.logCompanyTaxData.sussExclusionTo
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">
                          Campo 'Fecha hasta' <br />
                          modificado
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="6" v-if="taxData.sussExclusionNumber">
                      <pdf-file
                        v-bind:pdfFilePath.sync="taxData.sussExclusionPdf"
                        :habModificaPdf="!!taxData.sussExclusionNumber"
                        titulo="* Exclusión"
                        id="uploadPdfExclusion"
                        prop="sussExclusionPdf"
                      />
                    </el-col>
                    <el-col>
                      <div v-if="this.user !== null">
                        <span v-if="provider && provider.certifSuss.length > 0">
                          <el-alert
                            title="Tiene un certificado de exclusión vigente, por favor completar lo que corresponda"
                            type="info"
                            :closable="false"
                          >
                          </el-alert>
                        </span>
                        <span v-else> </span>
                      </div>
                      <div v-if="this.user === null">
                        <span v-if="this.certificationSussList.length > 0">
                          <el-alert
                            title="Tiene un certificado de exclusión vigente, por favor completar lo que corresponda"
                            type="info"
                            :closable="false"
                          >
                          </el-alert>
                        </span>
                        <span v-else> </span>
                      </div>
                    </el-col>
                  </el-row>

                  <el-divider>Retención I.V.A.</el-divider>
                  <el-form-item
                    label="¿Es agente de retención?"
                    :prop="'ivaRetentionAgent'"
                    style="width: 70%"
                  >
                    <el-col :span="5">
                      <el-switch
                        v-model="taxData.ivaRetentionAgent"
                        active-text="Si"
                        inactive-text="No"
                        active-value="1"
                        inactive-value="0"
                        :disabled="!editing"
                      >
                      </el-switch>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.ivaRetentionAgent !=
                          provider.logCompanyTaxData.ivaRetentionAgent
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">Campo modificado</div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                    <!--<span v-if="provider && provider.certifRg17.length > 0">-->
                    <div v-if="this.user !== null" style="padding-left: 25%">
                      <el-form :disabledData="false">
                        <span v-if="provider && provider.certifRg18.length > 0">
                          <el-tooltip placement="top">
                            <div slot="content">Certificado RG18</div>
                            <i class="el-icon-info"></i>
                            <el-button
                              style="margin-bottom: 0px"
                              size="mini"
                              type="primary"
                              plain
                              icon="el-icon-view"
                              @click="openCertificationRg18List()"
                              >Ver</el-button
                            >
                          </el-tooltip>
                        </span>
                        <span v-else>
                          <el-tooltip placement="top">
                            <div slot="content">Certificado RG18</div>
                            <i class="el-icon-info"></i>
                            <el-tag style="margin-left: 0%" type="warning"
                              >No se encontró</el-tag
                            >
                          </el-tooltip>
                        </span>
                      </el-form>
                    </div>
                    <div v-if="this.user === null">
                      <el-form :disabledData="false">
                        <span v-if="this.certificationRg18List.length > 0">
                          <el-tooltip placement="top">
                            <div slot="content">Certificado RG18</div>
                            <i class="el-icon-info"></i>
                            <el-button
                              style="margin-bottom: 0px"
                              size="mini"
                              type="primary"
                              plain
                              icon="el-icon-view"
                              @click="openCertificationRg18List()"
                              >Ver</el-button
                            >
                          </el-tooltip>
                        </span>
                        <span v-else>
                          <el-tooltip placement="top">
                            <div slot="content">Certificado RG18</div>
                            <i class="el-icon-info"></i>
                            <el-tag style="margin-left: 0%" type="warning"
                              >No se encontró</el-tag
                            >
                          </el-tooltip>
                        </span>
                      </el-form>
                    </div>
                  </el-form-item>

                  <pdf-file
                    v-if="
                      taxData.ivaRetentionAgent &&
                      taxData.ivaRetentionAgent !== '1'
                    "
                    v-bind:pdfFilePath.sync="taxData.ivaResolutionPdf"
                    :habModificaPdf="editing"
                    titulo="* Resolución"
                    id="uploadPdfResolucion"
                    prop="sussExclusionPdf"
                  />
                  <!-- <el-form-item
                    v-if="taxData.ivaRetentionAgent && taxData.ivaRetentionAgent !== '1'"
                    label="Resolución"
                    :prop="'ivaResolutionPdf'"
                  >
                    <el-upload
                      v-if="habModificaPdf"
                      class="upload-demo"
                      :ref="'taxData.sussExclusionPdf'"
                      :action="serverURI + 'api/uploadFile'"
                      :auto-upload="true"
                      accept="application/pdf"
                      :on-success="handlePdfResolutionIva"
                      :on-exceed="handleExceed"
                      :data="{
                        folder: 'altaProveedor',
                      }"
                      :limit="1"
                    >
                      <el-button slot="trigger" size="small" type="primary"
                        >Seleccionar archivo</el-button
                      >
                      <div slot="tip" class="el-upload__tip">
                        Solo se permiten archivos PDF
                      </div>
                    </el-upload>
                    <span v-else>
                      <a
                        v-if="taxData.ivaResolutionPdf"
                        :href="taxData.ivaResolutionPdf"
                        target="_blank"
                        style="padding-right: 20px"
                      >
                        <i class="fa fa-file-pdf-o" /> Ver
                      </a>
                      <span v-else> - </span>
                    </span>
                  </el-form-item> -->
                  <el-form
                    :model="taxData"
                    ref="taxDataForm"
                    id="formDatosImpositivos"
                    label-position="left"
                    label-width="25%"
                    :rules="rulesTaxDataIvaResolutionPdf"
                  >
                    <pdf-file
                      v-if="
                        taxData.ivaRetentionAgent &&
                        taxData.ivaRetentionAgent === '1'
                      "
                      v-bind:pdfFilePath.sync="taxData.ivaResolutionPdf"
                      :habModificaPdf="habModificaPdf"
                      titulo="* Resolución"
                      id="ivaResolutionPdf"
                      prop="ivaResolutionPdf"
                    />

                    <!-- <el-form-item
                      v-if="
                        taxData.ivaRetentionAgent && taxData.ivaRetentionAgent === '1'
                      "
                      label="Resolución"
                      :prop="'ivaResolutionPdf'"
                    >
                      <el-upload
                        v-if="habModificaPdf"
                        class="upload-demo"
                        :ref="'taxData.sussExclusionPdf'"
                        :action="serverURI + 'api/uploadFile'"
                        :auto-upload="true"
                        accept="application/pdf"
                        :on-success="handlePdfResolutionIva"
                        :on-exceed="handleExceed"
                        :data="{
                          folder: 'altaProveedor',
                        }"
                        :limit="1"
                      >
                        <el-button slot="trigger" size="small" type="primary"
                          >Seleccionar archivo</el-button
                        >
                        <div slot="tip" class="el-upload__tip">
                          Solo se permiten archivos PDF
                        </div>
                      </el-upload>
                      <span v-else>
                        <a
                          v-if="taxData.ivaResolutionPdf"
                          :href="taxData.ivaResolutionPdf"
                          target="_blank"
                          style="padding-right: 20px"
                        >
                          <i class="fa fa-file-pdf-o" /> Ver
                        </a>
                        <span v-else> - </span>
                      </span>
                    </el-form-item> -->
                    <el-form-item
                      label="Régimen de retención"
                      prop="ivaIdRetentionRegime"
                    >
                      <el-col :span="25" style="padding-right: 20px">
                        <el-select
                          id="regimenRetencion"
                          filterable
                          clearable
                          v-model="taxData.ivaIdRetentionRegime"
                          @change="updateIvaRetentionCategory"
                          :disabled="!editing"
                        >
                          <el-option
                            v-for="item in retentionRegimesVAT"
                            :key="item.idRetentionRegime"
                            :label="item.retentionRegime"
                            :value="item.idRetentionRegime"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col
                        :span="1"
                        v-if="
                          provider.taxData &&
                          provider.logCompanyTaxData &&
                          provider.taxData.ivaIdRetentionRegime !=
                            provider.logCompanyTaxData.ivaIdRetentionRegime
                        "
                      >
                        <el-tooltip placement="top">
                          <div slot="content">Campo modificado</div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </el-col>
                    </el-form-item>
                    <el-form-item
                      label="Categoría a retener"
                      prop="ivaIdCategoryRetain"
                    >
                      <el-col :span="25" style="padding-right: 20px">
                        <el-select
                          id="categoriaRetener"
                          filterable
                          clearable
                          v-model="taxData.ivaIdCategoryRetain"
                          :disabled="!editing"
                        >
                          <el-option
                            v-for="item in ivaRetentionCategories"
                            :key="item.idCategoryRetain"
                            :label="item.categoryRetain"
                            :value="item.idCategoryRetain"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col
                        :span="1"
                        v-if="
                          provider.taxData &&
                          provider.logCompanyTaxData &&
                          provider.taxData.ivaIdCategoryRetain !=
                            provider.logCompanyTaxData.ivaIdCategoryRetain
                        "
                      >
                        <el-tooltip placement="top">
                          <div slot="content">Campo modificado</div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </el-col>
                    </el-form-item>
                  </el-form>
                  <div v-if="this.user !== null">
                    <el-form :disabledData="false">
                      <span>Certificado de exclusión</span>
                      <!--<span v-if="provider && provider.certifSuss.length > 0">-->
                      <span v-if="provider && provider.certifRg17.length > 0">
                        <el-tooltip placement="top">
                          <div slot="content">Certificado RG17</div>
                          <i class="el-icon-info"></i>
                          <el-button
                            style="margin-left: 0px"
                            size="mini"
                            type="primary"
                            plain
                            icon="el-icon-view"
                            @click="openCertificationRg17List()"
                            >Ver</el-button
                          >
                        </el-tooltip>
                      </span>
                      <span v-else>
                        <el-tag type="warning">No se encontró</el-tag>
                      </span>
                    </el-form>
                  </div>
                  <div v-if="this.user === null">
                    <el-form :disabledData="false">
                      <span>Certificado de exclusión</span>
                      <!--<span v-if="provider && provider.certifSuss.length > 0">-->
                      <span v-if="this.certificationRg17List.length > 0">
                        <el-tooltip placement="top">
                          <div slot="content">Certificado RG17</div>
                          <i class="el-icon-info"></i>
                          <el-button
                            style="margin-left: 0px"
                            size="mini"
                            type="primary"
                            plain
                            icon="el-icon-view"
                            @click="openCertificationRg17List()"
                            >Ver</el-button
                          >
                        </el-tooltip>
                      </span>
                      <span v-else>
                        <el-tag type="warning">No se encontró</el-tag>
                      </span>
                    </el-form>
                  </div>
                  <br /><br />

                  <el-row :gutter="20"> </el-row>

                  <el-row :gutter="20">
                    <el-col :span="6">
                      <el-form-item :prop="'ivaExclusionNumber'" label="Número">
                        <el-input
                          v-model="taxData.ivaExclusionNumber"
                          maxlength="30"
                          :disabled="!editing"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="taxData.ivaExclusionNumber">
                      <el-form-item
                        label-width="0px"
                        label=""
                        :prop="'ivaExclusionFrom'"
                      >
                        <el-date-picker
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          :disabled="!taxData.ivaExclusionNumber"
                          v-model="taxData.ivaExclusionFrom"
                          type="date"
                          placeholder="Desde"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6" v-if="taxData.ivaExclusionNumber">
                      <el-form-item
                        label=""
                        label-width="0px"
                        :prop="'ivaExclusionTo'"
                      >
                        <el-date-picker
                          format="dd/MM/yyyy"
                          value-format="yyyy-MM-dd"
                          :picker-options="disabledDates"
                          :disabled="!taxData.ivaExclusionNumber"
                          v-model="taxData.ivaExclusionTo"
                          type="date"
                          placeholder="Hasta"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.ivaExclusionNumber !=
                          provider.logCompanyTaxData.ivaExclusionNumber
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">
                          Campo 'Número' <br />
                          modificado
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.ivaExclusionFrom !=
                          provider.logCompanyTaxData.ivaExclusionFrom
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">
                          Campo 'Fecha desde' <br />
                          modificado
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                    <el-col
                      :span="1"
                      v-if="
                        provider.taxData &&
                        provider.logCompanyTaxData &&
                        provider.taxData.ivaExclusionTo !=
                          provider.logCompanyTaxData.ivaExclusionTo
                      "
                    >
                      <el-tooltip placement="top">
                        <div slot="content">
                          Campo 'Fecha hasta' <br />
                          modificado
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="6" v-if="taxData.ivaExclusionNumber">
                      <pdf-file
                        v-bind:pdfFilePath.sync="taxData.ivaExclusionPdf"
                        :habModificaPdf="habModificaPdf"
                        titulo=""
                        id="ivaExclusionPdf"
                        prop="ivaExclusionPdf"
                      />

                      <!-- <el-form-item label="" label-width="0px" :prop="'ivaExclusionPdf'">
                        <el-upload
                          v-if="habModificaPdf"
                          :disabled="!taxData.ivaExclusionNumber"
                          class="upload-demo"
                          :ref="'taxData.ivaExclusionPdf'"
                          :action="serverURI + 'api/uploadFile'"
                          :auto-upload="true"
                          accept="application/pdf"
                          :on-success="handlePdfExclusionIva"
                          :on-exceed="handleExceed"
                          :data="{
                            folder: 'altaProveedor',
                          }"
                          :limit="1"
                        >
                          <el-button slot="trigger" size="small" type="primary"
                            >Seleccionar archivo</el-button
                          >
                          <div slot="tip" class="el-upload__tip">
                            Solo se permiten archivos PDF
                          </div>
                        </el-upload>
                        <span v-else>
                          <a
                            v-if="taxData.ivaExclusionPdf"
                            :href="taxData.ivaExclusionPdf"
                            target="_blank"
                            style="padding-right: 20px"
                          >
                            <i class="fa fa-file-pdf-o" /> Ver
                          </a>
                          <span v-else></span>
                        </span>
                      </el-form-item> -->
                    </el-col>
                    <el-col>
                      <div v-if="this.user !== null">
                        <span v-if="provider && provider.certifRg17.length > 0">
                          <el-alert
                            title="Tiene un certificado de exclusión vigente, por favor completar lo que corresponda"
                            type="info"
                            :closable="false"
                          >
                          </el-alert>
                        </span>
                        <span v-else> </span>
                      </div>
                      <div v-if="this.user === null">
                        <span v-if="this.certificationRg17List.length > 0">
                          <el-alert
                            title="Tiene un certificado de exclusión vigente, por favor completar lo que corresponda"
                            type="info"
                            :closable="false"
                          >
                          </el-alert>
                        </span>
                        <span v-else> </span>
                      </div>
                    </el-col>
                  </el-row>

                  <el-divider>Otros impuestos</el-divider>
                  <el-form
                    :model="taxData"
                    ref="taxDataForm"
                    id="formDatosImpositivosOi"
                    label-position="left"
                    label-width="25%"
                    :rules="rulesTaxDataOtros"
                  >
                    <el-form-item
                      label="Régimen de retención"
                      prop="otrosIdRetentionRegime"
                    >
                      <el-col :span="25" style="padding-right: 20px">
                        <el-select
                          id="regimenRetencion"
                          filterable
                          clearable
                          v-model="taxData.otrosIdRetentionRegime"
                          @change="updateOtrosRetentionCategory"
                          :disabled="!editing"
                        >
                          <el-option
                            v-for="item in retentionRegimesOTROS"
                            :key="item.idRetentionRegime"
                            :label="item.retentionRegime"
                            :value="item.idRetentionRegime"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col
                        :span="1"
                        v-if="
                          provider.taxData &&
                          provider.logCompanyTaxData &&
                          provider.taxData.otrosIdRetentionRegime !=
                            provider.logCompanyTaxData.otrosIdRetentionRegime
                        "
                      >
                        <el-tooltip placement="top">
                          <div slot="content">Campo modificado</div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </el-col>
                    </el-form-item>
                  </el-form>

                  <el-form
                    :model="taxData"
                    ref="taxDataForm"
                    id="formDatosImpositivosRe"
                    label-position="left"
                    label-width="25%"
                    :rules="rulesTaxDataOtros"
                  >
                    <el-form-item
                      label="Categoría a retener"
                      prop="otrosIdCategoryRetain"
                    >
                      <el-col :span="25" style="padding-right: 20px">
                        <el-select
                          id="categoriaRetener"
                          filterable
                          clearable
                          v-model="taxData.otrosIdCategoryRetain"
                          :disabled="!editing"
                        >
                          <el-option
                            v-for="item in otrosRetentionCategories"
                            :key="item.idCategoryRetain"
                            :label="item.categoryRetain"
                            :value="item.idCategoryRetain"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col
                        :span="1"
                        v-if="
                          provider.taxData &&
                          provider.logCompanyTaxData &&
                          provider.taxData.otrosIdCategoryRetain !=
                            provider.logCompanyTaxData.otrosIdCategoryRetain
                        "
                      >
                        <el-tooltip placement="top">
                          <div slot="content">Campo modificado</div>
                          <i class="el-icon-info"></i>
                        </el-tooltip>
                      </el-col>
                    </el-form-item>
                  </el-form>
                </el-form>

                <el-form
                  v-if="step === 3 && !provider"
                  :model="userData"
                  ref="userDataForm"
                  :rules="rulesUserData"
                  label-position="left"
                  label-width="25%"
                  id="formUsuario"
                  @submit.native.prevent=""
                >
                  <el-form-item label="Nombre y Apellido" prop="name">
                    <el-input type="text" v-model="userData.name"></el-input>
                  </el-form-item>

                  <el-form-item label="Correo electrónico" prop="email">
                    <el-input type="text" v-model="userData.email"></el-input>
                  </el-form-item>

                  <el-form-item label="Contraseña" prop="password">
                    <el-input
                      type="password"
                      v-model="userData.password"
                    ></el-input>
                  </el-form-item>

                  <el-form-item
                    label="Repetir contraseña"
                    prop="passwordRe"
                    :rules="[
                      {
                        pattern: userData.password,
                        message: 'Las contraseñas deben coincidir',
                        trigger: 'change',
                      },
                      {
                        required: true,
                        message: 'Campo obligatorio',
                        trigger: '',
                      },
                    ]"
                  >
                    <el-input
                      type="password"
                      v-model="userData.passwordRe"
                    ></el-input>
                  </el-form-item>
                </el-form>

                <div
                  class="row text-center"
                  v-if="
                    provider &&
                    provider[activeTab()].idCompanyDataStatus ===
                      status.ESPERANDO_CONFIRMACION &&
                    !user.isProvider
                  "
                >
                  <el-divider> Aceptar datos </el-divider>
                  <el-button
                    type="danger"
                    @click="verifyPermission()"
                    data-cy="btn-rechazar"
                  >
                    Rechazar <i class="el-icon-close"></i
                  ></el-button>
                  <el-button
                    type="success"
                    @click="acceptCompanyData()"
                    data-cy="btn-aceptar"
                  >
                    Aceptar <i class="el-icon-check"></i
                  ></el-button>
                </div>

                <el-card
                  class="box-card"
                  v-if="
                    provider &&
                    provider[activeTab()].idCompanyDataStatus ===
                      status.DEVUELTO
                  "
                  style="margin-bottom: 15px"
                >
                  <div slot="header" class="clearfix">
                    <span>Observaciones</span>
                  </div>
                  <div class="text item">
                    {{ provider[activeTab()].observation }}
                  </div>
                </el-card>

                <div
                  class="row text-center"
                  v-if="
                    provider &&
                    provider[activeTab()].idCompanyDataStatus ===
                      status.DEVUELTO &&
                    user.isProvider
                  "
                >
                  <el-button type="success" @click="reSendCompanyData">
                    Volver a enviar los datos
                  </el-button>
                </div>

                <el-button-group
                  v-if="
                    userByRoles ||
                    (dataAfip &&
                      (userIsAdmin || (user ? user.isProvider : true)))
                  "
                >
                  <el-button
                    data-cy="btn-anterior"
                    type="primary"
                    icon="el-icon-arrow-left"
                    v-if="step > 0 && !editing"
                    @click="previousStep()"
                    >Anterior</el-button
                  >
                  <el-button
                    data-cy="btn-siguiente"
                    type="primary"
                    icon="el-icon-arrow-right"
                    @click="nextStep()"
                    v-if="(step < 2 || (step === 2 && !provider)) && !editing"
                    >Siguiente</el-button
                  >
                  <el-button
                    type="success"
                    icon="el-check"
                    v-if="step === 3 && !provider"
                    @click="openModalTerminosYCond"
                    >Confirmar</el-button
                  >
                </el-button-group>
                <!---->
                <!-- <el-button-group v-if="">
                  <el-button type="primary" icon="el-icon-arrow-left" v-if="step > 0 && !editing" @click="previousStepView()">Anterior</el-button>
                  <el-button type="primary" icon="el-icon-arrow-right" @click="nextStepView()"  v-if="(step < 2 || step === 2 && !provider) && !editing">Siguiente</el-button>
                </el-button-group> -->
                <!---->
              </el-col>

              <!-- /input-group -->
            </div>
            <div class="row">
              <div
                class="col-md-12 text-center"
                v-if="response"
                style="margin-top: 5px"
              >
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="info-box">
                    <span class="info-box-icon bg-yellow"
                      ><i class="ion ion-android-alert"></i
                    ></span>
                    <div class="info-box-content">
                      <div
                        class="info-box-info"
                        v-for="field in response"
                        :key="field"
                      >
                        <ul style="font-size: 6px;" v-for="(error, index) in field" :key="index">
                          {{
                            error
                          }}
                        </ul>
                      </div>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!-- /.info-box -->
                </div>
              </div>
              <div
                class="col-md-12 text-center"
                v-if="success"
                style="margin-top: 5px"
              >
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div class="info-box">
                    <span class="info-box-icon bg-green"
                      ><i class="ion ion-android-checkmark-circle"></i
                    ></span>
                    <div class="info-box-content">
                      <span class="info-box-info">{{ success }}</span>
                    </div>
                    <!-- /.info-box-content -->
                  </div>
                  <!-- /.info-box -->
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
      <el-dialog
        title="Rechazar datos"
        :visible.sync="rejectCompanyDataVisible"
        :fullscreen="false"
        :lock-scroll="true"
      >
        Escriba el motivo por el cual rechaza los datos:
        <el-input
          type="textarea"
          :rows="4"
          style="margin-top: 20px"
          maxlength="400"
          placeholder="Ingrese el motivo"
          :show-word-limit="true"
          v-model="newObservation"
        >
        </el-input>

        <span slot="footer" class="dialog-footer">
          <el-button type="primary" v-on:click="rejectCompanyData()">
            Aceptar
          </el-button>
        </span>
      </el-dialog>
    </section>
  </div>
</template>
<script>
require('moment')
import { mapState } from 'vuex'
import datepicker from 'vue-date-picker'
import MaskedInput from 'vue-text-mask'
import api from '../../api'
import TheMask from 'vue-the-mask'
import config from '../../config'
import stage from '../../config/company_stage'
import rolesText from '../../config/roles'
import status from '../../config/data_status'

import PdfFile from '../PdfFile.vue'

export default {
  name: 'ConfirmProvider',
  components: { datepicker, TheMask, MaskedInput, PdfFile },
  computed: {
    ...mapState([
      'banks',
      'user',
      'bankBranches',
      'accountTypes',
      'regimenTypes',
      'jurisdictions',
      'retentionRegimes',
      'retentionRegimesVAT',
      'retentionRegimesOTROS',
      'retentionCategories',
      'retentionCategoriesVAT',
      'retentionCategoriesOTROS',
      'ibRetentionCategory'
      // 'sussRetentionCategories'
    ]),
    // datetime () {
    //   return new Date()
    // },
    services () {
      let services = this.$store.state.services
      if (services.sort) {
        return services.sort((a, b) => a.nombre > b.nombre)
      }
    },
    actualCountryFull () {
      if (this.actualCountry === 'AR') {
        return 'Argentina'
      }
      if (this.actualCountry === 'PE') {
        return 'Perú'
      }
    },
    countries () {
      if (this.$store.state.countries) {
        return this.$store.state.countries.sort((a, b) => a.country > b.country)
      }
    },
    sussRetentionCategory () {
      let lista = this.$store.state.sussRetentionCategory.sort(
        (a, b) => a.categoryRetain > b.categoryRetain
      )
      if (this.taxData.sussRetentionRegimen === '0') {
        return lista
      } else {
        lista = lista.filter((a) => {
          let auxiliar = a.auxiliar
          let agenteRet = JSON.parse(auxiliar)['AgenteRet'] === 'true'
          if (agenteRet) {
            return a
          }
        })
        return lista
      }
    },
    groupCompanies () {
      return this.$store.state.groupCompanies.sort(
        (a, b) => a.groupCompany > b.groupCompany
      )
    },
    storeRetentionRegime () {
      return this.$store.state.retentionRegimes
    },
    retentionRegimeList () {
      return this.$store.state.retentionRegimes.filter(
        (el) => el.idRetentionRegime === '3'
      )
    },
    statusList () {
      return this.$store.state.companyDataStatus
    }
  },
  data (router) {
    return {
      jurisdictionsHabilitadas: [],
      jurisdicciones: true,
      jurisdictionFlag: false,
      status: status,
      userIsAdmin: false,
      userByRoles: false,
      otrosRetentionCategories: [],
      retentionCategories2: [],
      retentionCategoriesAliquot: [],
      ivaRetentionCategories: [],
      disabledDates: {
        disabledDate (time) {
          return time.getTime() < Date.now()
          // to: new Date(Date.now() - 8640000)
        }
      },
      // sussRetentionCategories: [],
      // retentionRegimeList: [],
      doc1276: false,
      jurisdictionSantaFe: '',
      auxJurId: '',
      provider: '',
      actualCountry: '',
      providerLoaded: false,
      rejectCompanyDataVisible: false,
      disabledData: false,
      habModificaPdf: false,
      error: null,
      newObservation: '',
      statusType: '',
      types: ['warning', 'success', 'danger'],
      steps: ['generalData', 'paymentData', 'taxData'],
      idCompany: this.$route.params.id,
      idStep: this.$route.params.step,
      showModalCertificationExgain: false,
      showModalCertificationsExgainList: false,
      certificationExgainList: [],
      auxFlagEmptyExgainList: false,
      certificationExgain: [],
      showModalCertificationDatosAdicionales: false,
      showModalForm1276: false,
      showModalCertificationRg2681: false,
      showModalCertificationRg2681List: false,
      certificationRg2681List: [],
      certificationRg2681: [],
      showModalCertificationSussList: false,
      showModalCertificationSuss: false,
      certificationSussList: [],
      certificationSuss: [],
      showModalCertificationRg18List: false,
      showModalCertificationRg18: false,
      certificationRg18List: [],
      certificationRg18: [],
      showModalCertificationRg17List: false,
      showModalCertificationRg17: false,
      certificationRg17List: [],
      certificationRg17: [],
      checked2: false,
      aliquotData: {},
      step: 0,
      timeStampModifDate: '',
      editing: false,
      serverURI: config.serverURI,
      section: 'Solicitud',
      loading: '',
      providers: [],
      rut: '',
      options: [
        {
          value: '',
          label: ''
        }
      ],
      dataAfip: '',
      value: '',
      configuration: '',
      jwt: window.localStorage.getItem('token'),
      codigoEtica: '',
      politicaAnticorrupcion: '',
      politicaRelacionamiento: '',
      response: null,
      success: null,
      paramError: null,
      provinces: [],
      centrales: [],
      activeJurisdiction: '',
      activeJurisdictionSantaFe: '',
      coefficientFieldVerify: false,
      form1276loaded: false,
      form1276loadedAux: false,
      paramInvoices: null,
      rutMask: this.$store.state.rutMask,
      cuitMask: [
        /[1-9]/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/
      ],
      invoiceMask: this.$store.state.invoiceMask,
      terminosYCondVisible: false,
      checked: false,
      jurId: 0,
      generalData: {
        cuit: '',
        company: '',
        companyName: '', // Nombre de fantasia
        rubros: [],
        centrales: [],
        start_date: '',
        address: '',
        addressNumber: '',
        jurisdictionData: {},
        idProvince: '',
        idCountry: '',
        idGroupCompany: '',
        zipCode: '',
        city: '',
        paymentEmail: '',
        receiptEmail: '',
        typeIVA: '',
        personType: '',
        personSubType: '',
        personSubTypeOther: '',
        pdfAfip: '',
        namePrincipalContact: '',
        surnamePrincipalContact: '',
        phonePrincipalContact: '',
        emailPrincipalContact: '',
        nameCommercialContact: '',
        surnameCommercialContact: '',
        phoneCommercialContact: '',
        emailCommercialContact: '',
        modifDate: ''
      },
      rulesGeneralData: {
        cuit: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          {
            type: 'number',
            message: 'Solo están permitidos los números',
            trigger: ['blur', 'change']
          }
        ],
        company: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        rubros: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        start_date: [
          { required: false, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        centrales: [
          { required: false, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        address: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        addressNumber: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        idProvince: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        zipCode: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        city: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        idCountry: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        idGroupCompany: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        phonePrincipalContact: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        phoneCommercialContact: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        namePrincipalContact: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        nameCommercialContact: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        surnamePrincipalContact: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        surnameCommercialContact: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        emailPrincipalContact: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          {
            type: 'email',
            message: 'Debe ingresar un correo electrónico válido',
            trigger: 'blur'
          }
        ],
        emailCommercialContact: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          {
            type: 'email',
            message: 'Debe ingresar un correo electrónico válido',
            trigger: 'blur'
          }
        ],
        paymentEmail: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          {
            type: 'email',
            message: 'Debe ingresar un correo electrónico válido',
            trigger: 'blur'
          }
        ],
        receiptEmail: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          {
            type: 'email',
            message: 'Debe ingresar un correo electrónico válido',
            trigger: 'blur'
          }
        ],
        typeIVA: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        personType: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        personSubType: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        personSubTypeOther: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        pdfAfip: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ]
      },
      paymentData: {
        idBankBranch: '',
        idBank: '',
        accountNumber: '',
        idBankAccountType: '',
        cbu: '',
        pdfBank: ''
      },
      rulesPaymentData: {
        idBank: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        accountNumber: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' }
        ],
        idBankAccountType: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        cbu: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          {
            pattern: '[0-9]{22}',
            message: 'Deben ser 22 números',
            trigger: ['blur', 'change']
          }
        ],
        pdfBank: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ]
      },
      jurisdictionData: {
        idJurisdiction: '',
        coefficient: null,
        aliquot: null,
        certficateDetailsVisible: false, // Es para el modal
        certificateNumber: '',
        certificateFrom: null,
        certificateTo: null,
        agentDontOperateHere: false,
        certificatePdf: '',
        retentionAgentHas: 0,
        retentionAgentVisible: false, // Es para el modal
        retentionAgentDate: null,
        retentionAgentPdf: '',
        form1276pdf: '',
        perceptionAgentHas: 0,
        perceptionAgentVisible: false, // Es para el modal
        perceptionAgentDate: null,
        perceptionAgentPdf: ''
      },
      taxData: {
        pdfIb: '',
        ibType: '',
        pdfsExempt: '',
        idAgreementRegimeType: '',
        pdfCM05: '',
        jurisdictionHeadquarters: '',
        jurisdictions: [],
        earningsRetentionType: '',
        retentionRegimen: '',
        idEarningCategoryRetain: '',
        earningsExclusionNumber: '',
        earningsExclusionFrom: null,
        earningsExclusionTo: null,
        earningsExclusionPdf: '',
        sussEmployeer: 0,
        sussRetentionRegimen: 0,
        sussIdCategoryRetain: '',
        sussExclusionNumber: '',
        sussExclusionFrom: null,
        sussExclusionTo: null,
        sussExclusionPdf: '',
        ivaRetentionAgent: 0,
        ivaResolutionPdf: '',
        ivaIdRetentionRegime: '',
        ivaIdCategoryRetain: '',
        ivaExclusionNumber: '',
        otrosIdRetentionRegime: '',
        otrosIdCategoryRetain: '',
        ivaExclusionFrom: null,
        ivaExclusionTo: null,
        ivaExclusionPdf: ''
      },
      rulesTaxData: {
        pdfIb: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        ibType: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        pdfsExempt: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        idAgreementRegimeType: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        pdfCM05: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        jurisdictionHeadquarters: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        // 'jurisdictions': [
        //   { required: true, message: 'Campo obligatorio', trigger: 'change' }
        // ],
        earningsRetentionType: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        retentionRegimen: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        idEarningCategoryRetain: [
          {
            required: !!this.retentionCategories2,
            message: 'Campo obligatorio',
            trigger: 'change'
          }
        ],
        earningsExclusionFrom: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        earningsExclusionTo: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        earningsExclusionPdf: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        sussExclusionFrom: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        sussExclusionTo: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        sussExclusionPdf: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        ivaExclusionFrom: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        ivaExclusionTo: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ],
        ivaExclusionPdf: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ]
      },
      rulesTaxDataIvaResolutionPdf: {
        ivaResolutionPdf: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ]
      },
      rulesTaxDataOtros: {
        ivaResolutionPdf: [
          {
            required: false,
            message: 'Campo no obligatorio',
            trigger: 'change'
          }
        ]
      },
      rulesTaxDataForm1276Pdf: {
        form1276pdf: [
          { required: true, message: 'Campo obligatorio', trigger: 'change' }
        ]
      },
      userData: {
        name: '',
        email: '',
        password: '',
        passwordRe: ''
      },
      rulesUserData: {
        email: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          {
            type: 'email',
            message: 'Debe ingresar un correo electrónico válido',
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: 'Campo obligatorio', trigger: 'blur' },
          {
            min: 8,
            message: 'Debe tener mínimo 8 caracteres',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    provider: function (val) {
      this.loadProvider()
    }
  },
  methods: {
    validateCoefficient (key, jurId) {
      console.log('key ingresa: ', key)
      console.log(this.taxData.jurisdictions[jurId])
      const allowedCharacters = /^\d+(,\d{0,4})?$/
      if (!allowedCharacters.test(key)) {
        // si se coloca un caracter no permitido detras de la coma, eliminarlo.
        if (!allowedCharacters.test(key[key.length - 1])) {
          this.taxData.jurisdictions[jurId].coefficient = key.slice(0, -1)
          console.log('key correcta', this.taxData.jurisdictions[jurId].coefficient)
          return
        }
        key = key.replace(/[^0-9,\b]+/g, '')
        const parts = key.split(/,/)
        const integerPart = parts[0]
        let decimalPart = parts[1] || ''
        // Limitar a 4 decimales
        decimalPart = decimalPart.slice(0, 4)
        this.taxData.jurisdictions[jurId].coefficient = integerPart + (decimalPart ? ',' + decimalPart : '')
        console.log('key sale: ', this.taxData.jurisdictions[jurId].coefficient)
      } else {
        console.log('key correcta: ', key)
        this.taxData.jurisdictions[jurId].coefficient = key
      }
    },
    decimalCoefficient (coef) {
      return (coef.indexOf(',') !== -1 && coef.split(',')[0].length > 0 && coef.split(',')[1].length > 0)
    },
    clearAlicuotValue (jurId) {
      this.taxData.jurisdictions.forEach((jur, index) => {
        if (jur.idJurisdiction === jurId) {
          this.taxData.jurisdictions[index].aliquot = ''
        }
      })
    },
    changeAlicoutJurisdiction (jurId) {
      if (jurId !== null && jurId !== '') {
        const data = this.$store.state.ibRetentionCategory
          .filter((ret) => ret.idJurisdictions === jurId)
          .sort((a, b) => a.categoryRetain > b.categoryRetain)
        this.clearAlicuotValue(jurId)
        return data
      }
    },
    isAlicuotList (jurId) {
      if (jurId !== null && jurId !== '') {
        const data = this.$store.state.ibRetentionCategory.filter(
          (ret) => ret.idJurisdictions === jurId
        )
        return data.length > 0
      }
    },
    sussIdCategoryRetainClear () {
      this.taxData.sussIdCategoryRetain = ''
    },
    /* setRetentionRegime () {
      this.retentionRegimeList = this.$store.state.retentionRegimes.filter(el => el.idRetentionRegime === '3')
    }, */
    notify (notificationMessage) {
      this.$notify({
        title: '',
        type: 'warning',
        message: notificationMessage,
        duration: 10000,
        showClose: true,
        offset: 50
      })
    },
    editData () {
      this.editing = true
      this.disabledGeneralData()
    },
    cancelData () {
      this.editing = false
      this.disabledGeneralData()
    },
    saveData () {
      this.$confirm(
        'Sus Datos se remitirán a Albanesi para su verificación',
        'Atención',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      ).then(() => {
        this.editing = false
        this.disabledGeneralData()
        this.providerUpdateData()
      })
    },
    calculateHabModificaPdf () {
      const provider = (!!this.provider && this.provider !== '')
      this.habModificaPdf = !provider || this.editing || !this.disabledData
    },
    disabledGeneralData () {
      if (this.user && this.idCompany) {
        if (this.user.isProvider) {
          if (this.editing) {
            this.disabledData = false
            this.calculateHabModificaPdf()
            return
          } else {
            if (this.provider) {
              if (
                this.provider[this.activeTab()].idCompanyDataStatus ===
                status.DEVUELTO
              ) {
                this.disabledData = false
                this.calculateHabModificaPdf()
                return
              }
            }
          }
        } else {
          if (this.provider) {
            let activeTab = this.activeTab()
            console.log()
            if (this.provider[activeTab]) {
              if (
                this.provider[activeTab].idCompanyDataStatus !==
                status.ACEPTADO
              ) {
                this.disabledData = false
                this.calculateHabModificaPdf()
                return
              }
            }
          }
        }
      } else {
        this.disabledData = false
        this.calculateHabModificaPdf()
        return
      }
      this.disabledData = true
      this.calculateHabModificaPdf()
    },
    closeCertificationExgain () {
      this.showModalCertificationExgain = false
    },
    closeCertificationsExgainList () {
      this.showModalCertificationsExgainList = false
    },
    closeCertificationRg2681 () {
      this.showModalCertificationRg2681 = false
    },
    closeCertificationsRg2681List () {
      this.showModalCertificationRg2681List = false
    },
    closeCertificationSuss () {
      this.showModalCertificationSuss = false
    },
    closeCertificationsSussList () {
      this.showModalCertificationSussList = false
    },
    closeCertificationRg18 () {
      this.showModalCertificationRg18 = false
    },
    closeCertificationsRg18List () {
      this.showModalCertificationRg18List = false
    },
    closeCertificationRg17 () {
      this.showModalCertificationRg17 = false
    },
    closeCertificationsRg17List () {
      this.showModalCertificationRg17List = false
    },
    coeficienteValidacionTest () {
      return this.taxData.jurisdictions.some(function (el) {
        if (el.coefficient === null || el.coefficient === undefined) {
          // console.log('el.coefficient Nulo')
        } else {
          return el.coefficient.indexOf('.') > -1
        }
      })
    },
    verifySantaFeJurisdiction () {
      this.taxData.jurisdictions.forEach((juris) => {
        if (juris.idJurisdiction === '13') {
          if (this.activeJurisdictionSantaFe !== '') {
            if (this.taxData.jurisdictions[this.activeJurisdictionSantaFe]['form1276pdf'] !== null
            ) {
              console.log('hay una jurisdiccion santa fe con form1276 OK')
              this.form1276loaded = true
            } else if (
              this.taxData.jurisdictions[this.activeJurisdictionSantaFe]['form1276pdf'] === null
            ) {
              console.log(
                'hay una jurisdiccion santa fe con form1276 No cargado'
              )
              this.form1276loaded = false
            }
          } else {
            console.log('hay una jurisdiccion santa fe con form ERROR')
            this.form1276loaded = false
          }
          // console.log('hay una jurisdiccion santa fe')
        } else {
          // if (this.taxData.ibType !== 'Multilateral') {
          // console.log('NO hay una jurisdiccion santa fe')
          this.form1276loaded = true
          // }
        }
      })
    },
    getCertificationExgain (id) {
      this.certificationExgain = []
      // this.providers[0].certifExgain.forEach(certif => {
      // console.log(this.certificationExgainList)
      this.certificationExgainList.forEach((certif) => {
        if (certif.IdCertificationExGain === id) {
          this.certificationExgain.push({
            id: certif.IdCertificationExGain,
            cuit: certif.cuit,
            state: certif.state,
            publication: certif.publication,
            validity: certif.validity,
            period: certif.period,
            percentage: certif.percentage,
            number: certif.number,
            resolution: certif.resolution
          })
        }
      })
      // console.log(this.certificationExgain[0].cuit)
      this.showModalCertificationExgain = true
    },
    openCertificationExgainList () {
      // this.certificationExgainList = []
      if (this.user !== null) {
        this.certificationExgainList = []
        this.getCertificationExgainList()
      }
      this.showModalCertificationsExgainList = true
    },
    getCertificationExgainList () {
      this.providers[0].certifExgain.forEach((certif) => {
        this.certificationExgainList.push({
          IdCertificationExGain: certif.IdCertificationExGain,
          number: certif.number,
          publication: certif.publication,
          validity: certif.validity,
          cuit: certif.cuit,
          state: certif.state,
          period: certif.period,
          percentage: certif.percentage,
          resolution: certif.resolution
        })
      })
      // console.log(this.providers[0].certifRg2681)
      console.log(this.certificationExgainList)
    },
    getCertificationRg2681 (id) {
      this.certificationRg2681 = []
      // this.providers[0].certifRg2681.forEach(certif => {
      this.certificationRg2681List.forEach((certif) => {
        if (certif.idCertificationRG2681 === id) {
          this.certificationRg2681.push({
            id: certif.idCertificationRG2681,
            cuit: certif.cuit,
            type: certif.type,
            state: certif.state,
            stateDescription: certif.stateDescription,
            emision: certif.emision,
            administrationDate: certif.administrationDate,
            auth: certif.auth,
            ddjj: certif.ddjj,
            subsection: certif.subsection,
            since: certif.since,
            until: certif.until,
            number: certif.number,
            orderJud: certif.orderJud,
            modificationDate: certif.modificationDate
          })
        }
      })
      console.log(this.certificationRg2681[0].cuit)
      this.showModalCertificationRg2681 = true
    },
    openCertificationRg2681List () {
      if (this.user !== null) {
        this.certificationRg2681List = []
        this.getCertificationRg2681List()
      }
      this.showModalCertificationRg2681List = true
    },
    getCertificationRg2681List () {
      this.providers[0].certifRg2681.forEach((certif) => {
        this.certificationRg2681List.push({
          idCertificationRG2681: certif.idCertificationRG2681,
          cuit: certif.cuit,
          type: certif.type,
          state: certif.state,
          stateDescription: certif.stateDescription,
          emision: certif.emision,
          administrationDate: certif.administrationDate,
          auth: certif.auth,
          ddjj: certif.ddjj,
          subsection: certif.subsection,
          since: certif.since,
          until: certif.until,
          number: certif.number,
          orderJud: certif.orderJud,
          modificationDate: certif.modificationDate
        })
      })
      // console.log(this.providers[0].certifRg2681)
      console.log(this.certificationRg2681List)
    },
    getCertificationSuss (id) {
      this.certificationSuss = []
      // this.providers[0].certifSuss.forEach(certif => {
      this.certificationSussList.forEach((certif) => {
        if (certif.idCertificaction === id) {
          this.certificationSuss.push({
            id: certif.idCertificaction,
            cuit: certif.cuit,
            state: certif.state,
            since: certif.since,
            until: certif.until,
            number: certif.number,
            period: certif.period,
            resolution: certif.resolution,
            percentage: certif.percentage
          })
        }
      })
      this.showModalCertificationSuss = true
    },
    openCertificationSussList () {
      if (this.user !== null) {
        this.certificationSussList = []
        this.getCertificationSussList()
      }
      this.showModalCertificationSussList = true
    },
    getCertificationSussList () {
      this.providers[0].certifSuss.forEach((certif) => {
        this.certificationSussList.push({
          idCertificaction: certif.idCertificaction,
          cuit: certif.cuit,
          state: certif.state,
          since: certif.since,
          until: certif.until,
          number: certif.number,
          period: certif.period,
          resolution: certif.resolution,
          percentage: certif.percentage
        })
      })
    },
    getCertificationRg18 (id) {
      this.certificationRg18 = []
      // this.providers[0].certifRg18.forEach(certif => {
      this.certificationRg18List.forEach((certif) => {
        if (certif.idCertificationRG18 === id) {
          this.certificationRg18.push({
            id: certif.idCertificationRG18,
            cuit: certif.cuit,
            type: certif.type,
            since: certif.since,
            until: certif.until,
            name: certif.name
          })
        }
      })
      this.showModalCertificationRg18 = true
    },
    openCertificationRg18List () {
      if (this.user !== null) {
        this.certificationRg18List = []
        this.getCertificationRg18List()
      }
      this.showModalCertificationRg18List = true
    },
    getCertificationRg18List () {
      this.providers[0].certifRg18.forEach((certif) => {
        this.certificationRg18List.push({
          idCertificationRG18: certif.idCertificationRG18,
          cuit: certif.cuit,
          type: certif.type,
          since: certif.since,
          until: certif.until,
          name: certif.name
        })
      })
    },
    getCertificationRg17 (id) {
      this.certificationRg17 = []
      // this.providers[0].certifRg17.forEach(certif => {
      this.certificationRg17List.forEach((certif) => {
        if (certif.idCertificationRG17 === id) {
          this.certificationRg17.push({
            id: certif.idCertificationRG2681,
            cuit: certif.cuit,
            type: certif.type,
            rg: certif.rg,
            percentage: certif.percentage,
            since: certif.since,
            until: certif.until,
            name: certif.name
          })
        }
      })
      this.showModalCertificationRg17 = true
    },
    openCertificationRg17List () {
      if (this.user !== null) {
        this.certificationRg17List = []
        this.getCertificationRg17List()
      }
      this.showModalCertificationRg17List = true
    },
    getCertificationRg17List () {
      this.providers[0].certifRg17.forEach((certif) => {
        this.certificationRg17List.push({
          idCertificationRG17: certif.idCertificationRG2681,
          cuit: certif.cuit,
          type: certif.type,
          rg: certif.rg,
          percentage: certif.percentage,
          since: certif.since,
          until: certif.until,
          name: certif.name
        })
      })
    },
    getStatusNameOfTab () {
      let tabIdCompanyStatus =
        this.provider[this.activeTab()].idCompanyDataStatus
      this.statusType = this.types[tabIdCompanyStatus - 1]
      return this.getStatusName(tabIdCompanyStatus)
    },
    getStatusName (idCompanyDataStatus) {
      return this.statusList.find(
        (el) => el.idCompanyDataStatus === idCompanyDataStatus
      ).description
    },
    activeTab () {
      return this.steps[this.step]
    },
    handleCloseCompanyDataRejection () {
      this.newObservation = ''
    },
    reSendCompanyData () {
      let valido = this.validateFormFromStep()
      if (!valido) {
        return
      }
      this.setCurrentTimeStamp()
      console.log(this.timeStampModifDate)
      this.$confirm(
        '¿Está seguro que desea aceptar los datos?',
        'Advertencia',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(() => {
          this.provider['generalData'] = this.generalData
          this.provider['taxData'] = this.taxData
          this.provider['paymentData'] = this.paymentData
          console.log('data original', this.provider['taxData'])
          console.log('data nueva a ver', this.provider['taxData'])
          this.provider[this.activeTab()].idCompanyDataStatus =
            status.ESPERANDO_CONFIRMACION
          this.provider.idCompanyDataStatus = status.ESPERANDO_CONFIRMACION
          this.provider[this.activeTab()].modifDate = this.timeStampModifDate
          this.$store.state.userReturned = true
          this.updateCompanyData(
            this.activeTab(),
            this.provider[this.activeTab()]
          )
          console.log(this.$store.state.userReturned + '_ OK')
        })
        .catch(() => {
          this.$store.commit('TOGGLE_LOADING')
        })
    },
    companyData () {
      if (this.idCompany) {
        let that = this
        api
          .request(
            'GET',
            'api/ListCompanyData' + '?idCompany=' + this.idCompany + '&actualCountry=' + this.actualCountry
          )
          .then((response) => {
            var data = response.data
            if (data.error) {
              return
            }
            if (data) {
              that.providers = data
              that.provider = that.providers[0]
              that.disabledGeneralData()
            }
          })
          .catch((error) => {
            that.$store.commit('TOGGLE_LOADING')
            console.log(error)
          })
      }
    },
    getCentrales () {
      api.request('GET', 'api/generic/central')
        .then(response => {
          let data = response.data
          if (data.error) {
            return
          }
          if (data) {
            // that.$store.state.provinces = data
            this.centrales = data
          }
        })
    },
    setCurrentTimeStamp () {
      var d = new Date()
      var currDate = d.getDate()
      var currMonth = d.getMonth() + 1 // Months are zero based
      var currYear = d.getFullYear()
      var currHour = d.getHours()
      var currMinutes = d.getMinutes()
      var currSeconds = d.getSeconds()
      this.timeStampModifDate =
        '' +
        currYear +
        '-' +
        (currMonth <= 9 ? '0' + currMonth : currMonth) +
        '-' +
        (currDate <= 9 ? '0' + currDate : currDate) +
        ' ' +
        (currHour <= 9 ? '0' + currHour : currHour) +
        ':' +
        (currMinutes <= 9 ? '0' + currMinutes : currMinutes) +
        ':' +
        (currSeconds <= 9 ? '0' + currSeconds : currSeconds)
    },
    checkRoles (currentStep) {
      let permission = false
      this.user.roles.forEach((role) => {
        switch (role.rolesId) {
          case rolesText.AUTORIZADOR_DG:
            if (currentStep === 0) {
              permission = true
            }
            break
          case rolesText.AUTORIZADOR_DI:
            if (currentStep === 2) {
              permission = true
            }
            break
          case rolesText.AUTORIZADOR_DP:
            if (currentStep === 1) {
              permission = true
            }
            break
          case rolesText.ADMIN_SISTEMA:
            permission = true
            break
          default:
            break
        }
      })
      return permission
    },
    acceptCompanyData () {
      let solicitud = true
      if (this.provider.idStage === '3') {
        solicitud = false
      }
      let permission = this.checkRoles(this.step)
      if (!permission) {
        console.log('Permision es :' + permission)
        this.$router.push('/newProviders')
        this.$alert(
          'No tiene los permisos requeridos para realizar esta accion',
          'Permisos Insuficientes',
          {
            confirmButtonText: 'Aceptar',
            callback: (action) => {
              this.$router.push('/newProviders')
            }
          }
        )
        return
      }
      // console.log(this.provider.idStage)
      this.$confirm(
        '¿Está seguro que desea aceptar los datos?',
        'Advertencia',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(() => {
          this.provider[this.activeTab()] = this[this.activeTab()]
          this.provider[this.activeTab()].idCompanyDataStatus = status.ACEPTADO
          this.provider[this.activeTab()].idUser = this.user.idUser
          this.provider.signUpStatus++
          this.updateCompanyData(
            this.activeTab(),
            this.provider[this.activeTab()]
          )
          if (solicitud) {
            this.solicitudActivarUsuario()
          }
          this.$parent.getProviders()
          if (!this.checkRoles(this.step + 1)) {
            this.$router.push('/newProviders')
          }
        })
        .catch(() => {})
    },
    verifyPermission () {
      let permission = this.checkRoles(this.step)
      if (!permission) {
        this.$router.push('/newProviders')
        this.$alert(
          'No tiene los permisos requeridos para realizar esta accion',
          'Permisos Insuficientes',
          {
            confirmButtonText: 'Aceptar',
            callback: (action) => {
              this.$router.push('/newProviders')
            }
          }
        )
        return
      }
      this.rejectCompanyDataVisible = true
    },
    rejectCompanyData () {
      if (this.newObservation === '') {
        this.$message.warning('Falta completar el motivo')
        return
      }
      this.$confirm(
        '¿Está seguro que desea rechazar los datos por este motivo?',
        'Advertencia',
        {
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(() => {
          this.provider[this.activeTab()] = this[this.activeTab()]
          this.provider[this.activeTab()].idCompanyDataStatus = status.DEVUELTO
          this.provider[this.activeTab()].idUser = this.user.idUser
          this.provider[this.activeTab()].observation = this.newObservation
          this.updateCompanyData(
            this.activeTab(),
            this.provider[this.activeTab()]
          )
          this.$router.push('/newProviders')
        })
        .catch(() => {})
    },
    isSystemAdmin () {
      if (this.user) {
        this.user.roles.forEach((role) => {
          if (role.rolesId === rolesText.ADMIN_SISTEMA) {
            this.userIsAdmin = true
          }
          if (
            role.rolesId === rolesText.AUTORIZADOR_DG ||
            role.rolesId === rolesText.AUTORIZADOR_DI ||
            role.rolesId === rolesText.AUTORIZADOR_DP
          ) {
            this.userByRoles = true
          }
        })
      }
    },
    // saveAliquotValues () {
    //   if (this.aliquotData.length > 0) {
    //     this.provider.taxData.jurisdictions = this.provider.taxData.jurisdictions.map(jurisdiction => {
    //       const index = jurisdiction.aliquot
    //       const value = this.aliquotData[index]
    //       jurisdiction.aliquot = value
    //       return jurisdiction
    //     })
    //   }
    // },
    providerUpdateData () {
      // this.saveAliquotValues()
      console.log('activeTab', this[this.activeTab()])
      this.provider[this.activeTab()] = this[this.activeTab()]
      console.log('nuevo active tab test', this[this.activeTab()])
      this.provider[this.activeTab()].idUser = this.user.idUser
      this.provider[this.activeTab()].idCompanyDataStatus =
        status.ESPERANDO_CONFIRMACION
      this.setCurrentTimeStamp()
      this.provider[this.activeTab()].modifDate = this.timeStampModifDate
      this.provider.idCompanyStatus = status.ESPERANDO_CONFIRMACION
      this.provider.idCompanyDataStatus = status.MODIFICADO // 1
      this.provider.isExport = '0'
      // this.provider[this.activeTab()].jurisdictions.forEach((jur) => {
      //   if (jur.coefficient) {
      //     const integerPart = jur.coefficient.split(',')[0]
      //     const decimalPart = jur.coefficient.split(',')[1] || ''
      //     if (decimalPart !== '') {
      //       jur.coefficient = integerPart + ',' + decimalPart
      //     } else {
      //       jur.coefficient = integerPart
      //     }
      //   }
      // })
      this.taxData.jurisdictions.forEach((jurisdiction) => {
        if (!this.decimalCoefficient(jurisdiction.coefficient)) {
          this.notify('Coef. Unificado debe ser un número decimal')
          this.jurisdictionFlag = true
        }
      })
      if (this.jurisdictionFlag) {
        this.jurisdictionFlag = false
        return
      } else {
        this.updateCompanyData(this.activeTab(), this.provider[this.activeTab()])
      }
      // this.updateCompanyData(this.activeTab(), this.provider[this.activeTab()])
    },
    activationOrReject () {
      // Condiciones simples para asignar el idCompanyCompanyDataStatus
      var genD = this.provider.generalData.idCompanyDataStatus
      var payD = this.provider.paymentData.idCompanyDataStatus
      var taxD = this.provider.taxData.idCompanyDataStatus

      if (
        genD === status.ACEPTADO &&
        payD === status.ACEPTADO &&
        taxD === status.ACEPTADO
      ) {
        this.provider.idCompanyDataStatus = status.ACEPTADO
        this.provider.idCompanyStatus = status.ACEPTADO
        setTimeout(() => {
          api
            .request(
              'GET',
              'api/sendMailUserActivation/' + this.provider.idCompany
            )
            .then(() => {})
        }, 900)
      } else {
        if (
          genD === status.DEVUELTO ||
          payD === status.DEVUELTO ||
          taxD === status.DEVUELTO
        ) {
          this.provider.idCompanyDataStatus = status.DEVUELTO
          this.provider.idCompanyStatus = status.RECHAZADO
          setTimeout(() => {
            api
              .request('GET', 'api/sendMailUserReject/' + this.provider.idCompany)
              .then(() => {})
          }, 900)
        }
      }
    },
    updateCompanyData (dataType, data) {
      // Condiciones simples para asignar el idCompanyCompanyDataStatusole.log(status.ESPERANDO_CONFIRMACION)
      var genD = this.provider.generalData.idCompanyDataStatus
      var payD = this.provider.paymentData.idCompanyDataStatus
      var taxD = this.provider.taxData.idCompanyDataStatus
      this.activationOrReject()
      // Condiciones simples para asignar el idStage
      if (genD === status.ESPERANDO_CONFIRMACION) {
        this.provider.idStage = stage.DATOS_GENERALES
      } else if (payD === status.ESPERANDO_CONFIRMACION) {
        this.provider.idStage = stage.DATOS_BANCARIOS
      } else if (taxD === status.ESPERANDO_CONFIRMACION) {
        this.provider.idStage = stage.DATOS_IMPOSITIVOS
      }
      api
        .request(
          'POST',
          'api/generic/company/' + this.provider.idCompany,
          JSON.stringify(this.provider)
        )
        .then(() => {
          let idCompanyData
          switch (dataType) {
            case 'generalData':
              idCompanyData = this.provider.idCompany
              break
            case 'paymentData':
              idCompanyData = this.provider.idCompany
              break
            case 'taxData':
              idCompanyData = this.provider.idCompany
              break
          }
          this.$store.commit('START_LOADING')
          api
            .request(
              'POST',
              'api/generic/' + dataType + '/' + idCompanyData,
              JSON.stringify(data)
            )
            .then((response) => {
              switch (dataType) {
                case 'generalData':
                  this.provider.cuit = this.generalData.cuit
                  this.provider.company = this.generalData.company
                  this.provider.companyName = this.generalData.companyName
                  api
                    .request(
                      'POST',
                      'api/generic/company/' + this.provider.idCompany,
                      JSON.stringify(this.provider)
                    )
                  break
                // case 'taxData':
                //   this.taxData.jurisdictions.forEach((item) => {
                //     api.request(
                //       'POST',
                //       'api/generic/companyJurisdictionData/' +
                //         item.idCompanyJurisdictionData,
                //       JSON.stringify(item)
                //     )
                //   })
                //   break
              }
              this.rejectCompanyDataVisible = false
              this.newObservation = ''
              this.$store.commit('STOP_LOADING')
              this.provider[dataType] = response.data
              this.user.roles.forEach((role) => {
                if (
                  role.rolesId === rolesText.AUTORIZADOR_DG
                ) {
                  this.$router.push('/newProviders')
                }
                if (
                  role.rolesId === rolesText.AUTORIZADOR_DI
                ) {
                  this.$router.push('/newProviders')
                }
                if (
                  role.rolesId === rolesText.AUTORIZADOR_DP
                ) {
                  this.$router.push('/newProviders')
                }
              })

              this.$message.success('Estado cambiado satisfactoriamente')
            })
            .catch((error) => {
              console.log(error)
              this.$store.commit('STOP_LOADING')
              this.$message.danger('Error al cambiar el estado')
            })
        })
    },
    isSantaFe (idJurisdiction) {
      let jurisdiction = this.jurisdictions.find(
        (prov) => prov.idJurisdictions === idJurisdiction
      )
      if (jurisdiction) {
        return jurisdiction.jurisdictions === 'Santa Fe'
      }
      return false
    },
    addDoc1276 (idJurisdiction) {
      if (this.taxData.ibType === 'Local') {
        if (idJurisdiction === '13') {
          this.doc1276 = true
        } else {
          this.doc1276 = false
        }
      }
      if (this.taxData.ibType === 'Multilateral') {
        if (idJurisdiction === '13') {
          this.doc1276 = true
        } /* else {
          this.doc1276 = false
        } */
      }
    },
    coefficientValidate (rule, value, callback) {
      if (!(value && Math.floor(value) <= 9 && value.toString().length === 6)) {
        callback(new Error())
      }
      callback()
    },
    aliquotValidate (rule, value, callback) {
      if (!value) {
        callback()
      }
      if (!(value && Math.floor(value) <= 9 && value.toString().length === 4)) {
        callback(new Error())
      }
    },
    openModalTerminosYCond () {
      let valido = this.validateFormFromStep()
      if (valido) {
        this.terminosYCondVisible = true
      }
    },
    openModalCertificateDetails (index) {
      this.activeJurisdiction = index
      this.showModalCertificationDatosAdicionales = true
      // this.taxData.jurisdictions[index].certficateDetailsVisible = true
      // console.log(this.taxData.jurisdictions[index].certficateDetailsVisible)
    },
    openModalForm1276 (index) {
      this.activeJurisdiction = index
      this.activeJurisdictionSantaFe = index
      this.showModalForm1276 = true
    },
    openModalRetentionAgent (index) {
      this.activeJurisdiction = index
      this.taxData.jurisdictions[index].retentionAgentVisible =
        this.taxData.jurisdictions[index].retentionAgentHas === '1'
    },
    openModalPerceptionAgent (index) {
      this.activeJurisdiction = index
      this.taxData.jurisdictions[index].perceptionAgentVisible =
        this.taxData.jurisdictions[index].perceptionAgentHas === '1'
    },
    handleIbType () {
      if (
        this.taxData.ibType === 'Multilateral' &&
        this.taxData.jurisdictions.length === 1
      ) {
        this.addJurisdiction()
      } else if (this.taxData.jurisdictions.length === 2) {
        this.deleteJurisdiction(this.taxData.jurisdictions[1])
      }
    },
    addJurisdiction () {
      this.taxData.jurisdictions.push(Object.assign({}, this.jurisdictionData))
    },
    deleteJurisdiction (item) {
      var index = this.taxData.jurisdictions.indexOf(item)
      if (index !== -1) {
        this.taxData.jurisdictions.splice(index, 1)
      }
    },
    handleExceed (files, fileList) {
      this.$message.warning('Solo se permite un archivo')
    },
    nextStep () {
      let valido = false
      if (this.step === 2) {
        this.verifySantaFeJurisdiction()
        this.coeficienteValidacionTest()
        // Comment#1 Validación Form1276 { Entra en el 'if' y en el 'else' solo si se selecciona Jurisdiccion 'Santa Fe'
        valido = this.validateFormFromStep()
        if (valido) {
          if (this.form1276loaded === true) {
            let that = this
            this.$refs['taxDataForm'].validate((valid) => {
              if (valid) {
                // that.jurisdicciones = false
                that.step++
                that.disabledGeneralData()
              }
            })
          } else {
            this.step = 2
            if (this.form1276loaded === false) {
              this.notify('Formulario 1276 obligatorio')
            }
            this.form1276loadedAux = true
          }
        }
      } else {
        valido = this.validateFormFromStep()
        if (valido) {
          this.step++
          this.disabledGeneralData()
        }
      }
      this.calculateHabModificaPdf()
    },
    previousStep () {
      this.step--
      if (this.step === 2) {
        this.jurisdicciones = true
      }
      this.disabledGeneralData()
      this.calculateHabModificaPdf()
    },
    previousStepView () {
      this.step-- // #sinUso
    },
    nextStepView () {
      this.step++ // #sinUso
    },
    validacionGeneralDataForm () {
      if (!this.generalData.pdfAfip) {
        this.notify('Comprobante alta de AFIP es Obligatorio')
        return false
      }
      return true
    },
    validacionBanklDataForm () {
      if (!this.paymentData.pdfBank) {
        this.notify('Pdf de Constancia es Obligatorio')
        return false
      }
      return true
    },
    validacionTaxDataForm () {
      this.$refs['taxDataForm'].validate()
      if (!this.taxData.pdfIb) {
        this.notify('Formulario Constancia Ingresos Brutos Obligatorio')
        return false
        // IIBB MULTILATERAL
      } else if (this.taxData.ibType === 'Multilateral') {
        if (!this.taxData.idAgreementRegimeType) {
          this.notify('Se debe seleccionar un Regimen de Convenio de IIBB')
          return false
        }
        if (!this.taxData.pdfCM05) {
          this.notify('Formulario CM05 Obligatorio')
          return false
        }
        if (!this.taxData.jurisdictionHeadquarters) {
          this.notify('Debe seleccionar jurisdicción sede')
          return false
        }
        // IIBB LOCAL
      } else if (this.taxData.ibType === 'Local') {
        if (!this.taxData.jurisdictionHeadquarters) {
          this.notify('Debe seleccionar jurisdicción sede')
          return false
        }
        // IIBB EXENTO
      } else if (this.taxData.ibType === 'Exento') {
        if (!this.taxData.pdfsExempt || this.taxData.pdfsExempt === '') {
          this.notify('Formulario Contancia de Exento de IIBB es Obligatorio')
          return false
        }
      } else if (!this.taxData.ibType) {
        this.notify('Se debe seleccionar un tipo de convenio de IIBB')
        return false
      }
      if (
        !this.taxData.jurisdictions ||
        (!this.taxData.jurisdictions[0].aliquot &&
        !this.taxData.jurisdictions[0].aliquota_value) ||
        !this.taxData.jurisdictions[0].coefficient
      ) {
        this.notify('Faltan completar datos de jurisdicción de IIBB')
        return false
      }
      // Para todos IB
      if (!this.taxData.jurisdictionHeadquarters) {
        this.notify('Se debe seleccionar una Jurisdicción Sede de IIBB')
        return false
      }
      // RETENCION DE GANANCIAS
      if (!this.taxData.earningsRetentionType) {
        this.notify('Se debe seleccionar el tipo de Retención de Ganancias')
        return false
      }
      // RETENCION IVA
      if (this.taxData.ivaExclusionPdf !== '') {
        if (this.taxData.ivaIdCategoryRetain === '') {
          this.notify('Se debe seleccionar la Categoría a Retener de IVA')
          return false
        }
      }
      // INSCRIPTO
      if (this.taxData.earningsRetentionType === 'Inscripto') {
        if (!this.taxData.retentionRegimen) {
          this.notify('Debe informar el Regimen de Retención de Ganancias')
          return false
        }
        if (!this.taxData.idEarningCategoryRetain) {
          this.notify('Debe informar la Categoría a Retener de Ganancias')
          return false
        }
      }
      return true
    },
    validateFormFromStep () {
      let formName
      switch (this.step) {
        case 0:
          formName = 'generalDataForm'
          break
        case 1:
          formName = 'paymentDataForm'
          break
        case 2:
          formName = 'taxDataForm'
          break
        case 3:
          formName = 'userDataForm'
          break
      }
      let respuesta
      respuesta = this.validateForm(formName)
      if (respuesta) {
        if (formName === 'generalDataForm') {
          respuesta = this.validacionGeneralDataForm()
        } else if (formName === 'paymentDataForm') {
          respuesta = this.validacionBanklDataForm()
        } else if (formName === 'taxDataForm') {
          respuesta = this.validacionTaxDataForm()
        }
      }
      return respuesta
    },
    updateProvinces (idCountry) {
      // this.generalData.idProvince = ''
      this.provinces = this.$store.state.provinces
        .filter((prov) => prov.idCountry === idCountry)
        .sort((a, b) => a.province > b.province)
    },
    updateRetentionCategory (idRetention) {
      this.taxData.idEarningCategoryRetain = ''
      let temporal = this.$store.state.retentionCategories
        .filter((ret) => ret.idRetentionRegime === idRetention)
        .sort((a, b) => a.categoryRetain > b.categoryRetain)
      this.retentionCategories2 = temporal
    },
    updateAliquot (idJurisdiction, index) {
      this.retentionCategoriesAliquot[index] = this.ibRetentionCategory
      .filter((ret) => ret.idJurisdictions === idJurisdiction)
      .sort((a, b) => a.categoryRetain > b.categoryRetain)
      if ((this.provider.taxData.jurisdictions[index].aliquot)) {
        // console.log('this.provider.taxData.jurisdictions[index].aliquot', this.provider.taxData.jurisdictions[index].aliquot)
        // console.log('this.ibRetentionCategory', this.ibRetentionCategory)
        // let findAliquotName = this.ibRetentionCategory.filter((ret) => ret.idCategoryRetain === this.provider.taxData.jurisdictions[index].aliquot)[0].categoryRetain
        // console.log('find aliquot name', findAliquotName)
        // let findAliquotName = this.ibRetentionCategory.filter((ret) => ret.categoryRetain === this.provider.taxData.jurisdictions[index].aliquot).length === 0 ? this.provider.taxData.jurisdictions[index].aliquot : this.provider.taxData.jurisdictions[index].aliquot[0].idCategoryRetain
        // this.provider.taxData.jurisdictions[index].aliquot = findAliquotName
      }
      // this.addDoc1276(idJurisdiction)
      if (idJurisdiction === '13') {
        this.doc1276 = true
      } else {
        this.doc1276 = false
      }
    },
    updateIvaRetentionCategory (idRetention) {
      this.ivaRetentionCategories = this.$store.state.retentionCategoriesVAT
        .filter((ret) => ret.idRetentionRegime === idRetention)
        .sort((a, b) => a.categoryRetain > b.categoryRetain)
    },
    updateOtrosRetentionCategory (idRetention) {
      this.otrosRetentionCategories = this.$store.state.retentionCategoriesOTROS
        .filter((ret) => ret.idRetentionRegime === idRetention)
        .sort((a, b) => a.categoryRetain > b.categoryRetain)
    },
    handlePdfResolutionIva (response, file, fileList) {
      this.taxData.ivaResolutionPdf = response
    },
    handlePdfExclusionIva (response, file, fileList) {
      this.taxData.ivaExclusionPdf = response
    },
    handlePdfExclusionSuss (response, file, fileList) {
      this.taxData.sussExclusionPdf = response
    },
    handlePdfExclusionEarnings (response, file, fileList) {
      this.taxData.earningsExclusionPdf = response
    },
    handlePdfCertificate (response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].certificatePdf =
        response
    },
    handlePdfRetentionAgent (response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].retentionAgentPdf =
        response
    },
    handlePdfForm1276 (response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].form1276pdf = response
    },
    handlePdfPerceptionAgent (response, file, fileList) {
      this.taxData.jurisdictions[this.activeJurisdiction].perceptionAgentPdf =
        response
    },
    validateForm (formName) {
      let that = this
      var validated = true
      if (that.$refs[formName]) {
        that.$refs[formName].validate((valid) => {
          if (!valid) {
            validated = valid
          }
        })
      } else {
        validated = false
      }
      return validated
    },
    editCuit () {
      this.dataAfip = ''
    },
    nextPage () {
      this.step++ // #sinUso
    },
    submitFormSolicitud () {
      this.solicitudActivarUsuario('1')
      if (this.checked2 === true && this.checked === true) {
        this.terminosYCondVisible = false
        this.checkData()
      } else {
        this.checked2 = false
        this.checked = false
        this.terminosYCondVisible = true
      }
    },
    clearInput (vueModel) {
      vueModel = ''
    },
    verifyCuit () {
      this.$refs['generalDataForm'].validateField('cuit', (valid) => {
        if (!valid) {
          this.$store.commit('START_LOADING')
          api
            .request('GET', 'api/getPersonaAfip/' + this.generalData.cuit)
            .then((response) => {
              // console.log(response)
              if (typeof response.data === 'string') {
                this.dataAfip = ''
                this.$message({
                  message: response.data.replace('Id', 'CUIT'),
                  type: 'warning'
                })
              } else {
                if (!response.data.errorConstancia) {
                  this.dataAfip = response.data.datosGenerales
                  if (this.dataAfip.tipoPersona === 'JURIDICA') {
                    this.generalData.company = this.dataAfip.razonSocial
                  } else {
                    this.generalData.company =
                      (this.dataAfip.nombre ? this.dataAfip.nombre + ' ' : '') +
                      this.dataAfip.apellido
                  }
                  api
                    .request(
                      'GET',
                      'api/allCertification/' + this.generalData.cuit
                    )
                    .then((response) => {
                      // console.log('CERTIFICADOS')
                      // console.log(response.data['exgainCertification'])
                      if (response.data['exgainCertification'].length === 0) {
                        // this.certificationExgainList = response.data['exgainCertification']
                        this.auxFlagEmptyExgainList = true
                        // console.log(this.auxFlagEmptyExgainList)
                      }
                      this.certificationExgainList =
                        response.data['exgainCertification']
                      // this.$store.state.allCertification = response.data['exgainCertification']
                      // console.log('STORE')
                      // console.log(this.$store.state.allCertification)
                      // this.certificationExgainList.push({'IdCertificationExGain': certif.IdCertificationExGain, 'number': certif.number, 'publication': certif.publication, 'validity': certif.validity})
                      this.certificationSussList =
                        response.data['sussCertification']
                      this.certificationRg18List =
                        response.data['rg18Certification']
                      this.certificationRg17List =
                        response.data['rg17Certification']
                      this.certificationRg2681List =
                        response.data['rg2681Certification']
                    })
                  this.$message({
                    message: 'CUIT verificado correctamente en AFIP',
                    type: 'success'
                  })
                } else {
                  let mensaje = ''
                  if (typeof response.data.errorConstancia.error === 'string') {
                    mensaje = response.data.errorConstancia.error
                  } else {
                    mensaje = response.data.errorConstancia.error.join('\n')
                  }
                  this.$message({
                    message: 'Informa AFIP : \n' + mensaje,
                    type: 'error'
                  })
                }
              }
              this.$store.commit('STOP_LOADING')
            })
            .catch((error) => {
              console.log(error)
              this.$store.commit('STOP_LOADING')
            })
        }
      })
    },
    checkData () {
      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')
      /* Making API call to authenticate a user */
      // api.request('GET', 'api/solicitudUsuario' + '?rut=' + rut + '&invoice0=' + invoice0 + '&date0=' + date0 + '&invoice1=' + invoice1 + '&date1=' + date1 + '&invoice2=' + invoice2 + '&date2=' + date2 + '&name=' + name + '&reason=' + reason + '&email=' + email)
      let url = 'api/saveNewProvider'
      let url2 = '/login'
      if (this.user) {
        url = 'api/saveNewProviderRegister'
        url2 = '/providers'
      }
      api
        .request('POST', url, {
          generalData: this.generalData,
          paymentData: this.paymentData,
          taxData: this.taxData,
          userData: this.userData
        })
        .then((response) => {
          this.toggleLoading()
          var data = response.data
          /* Checking if error object was returned from the server */
          if (response.data.error) {
            var errorName = response.data.error.name
            if (errorName) {
              console.log(errorName)
              this.checked = false
              this.checked2 = false
              if (errorName === 'InvalidArgumentError') {
                this.response = 'Los datos son incorrectos.'
              } else if (errorName === 'NotFoundError') {
                this.response = 'Se ha producido un error inesperado.'
              } else {
                this.response = errorName
              }
            } else {
              this.response = data.error
            }

            return
          } else {
            if (data.success) {
              // api.request('GET', 'api/sendMailSignUp/' + response.data.idUser)
              // .then(response => {
              // })
              api
                .request('POST', 'api/sendSignUpMessage', {
                  idEmisor: 1,
                  idReceptor: response.data.idUser,
                  message:
                    'Gracias por registrarse, Estamos revisando la información remitida',
                  messageType: 1
                })
                .then((response) => {})
              this.$alert(
                'Sus datos se han remitido correctamente, muchas gracias!',
                'Información Enviada',
                {
                  confirmButtonText: 'Confirmar',
                  callback: (action) => {
                    this.$router.push(url2)
                  }
                }
              )
              this.success = data.success
            }
          }
        })
        .catch((error) => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error)

          this.response = error.response.data
          this.toggleLoading()
        })
    },
    toggleLoading () {
      this.loading = this.loading === '' ? 'cargando' : ''
    },
    resetResponse () {
      this.response = ''
      this.success = ''
    },
    loadProvider () {
      console.log(this.provider)
      if (this.providerLoaded) {
        return
      }
      this.providerLoaded = true
      Object.assign(this.generalData, this.provider.generalData)
      this.generalData.cuit = parseInt(this.provider.cuit)
      this.generalData.company = this.provider.company
      this.generalData.companyName = this.provider.companyName
      this.generalData.rubros = this.provider.rubros.map((el) => el.idRubro)
      this.generalData.centrales = this.provider.generalData.centrales !== undefined ? this.provider.generalData.centrales.map((el) => el) : undefined
      this.updateProvinces(this.generalData.idCountry)
      if (this.provider && this.provider.taxData) {
        if (this.provider.taxData.retentionRegimen) {
          this.updateRetentionCategory(this.provider.taxData.retentionRegimen)
        }
        // this.updateAliquot(
        //   this.provider.taxData.jurisdictions[0]['idJurisdiction']
        // )
      }
      this.setIbJurisdiction()
      // console.log('ALICUOTA')
      // console.log(this.jurisdictions)
      // console.log(this.provider.taxData.jurisdictions[0]['idJurisdiction'])
      // this.setRetentionRegime()
      this.updateIvaRetentionCategory(
        this.provider.taxData.ivaIdRetentionRegime
      )
      this.updateOtrosRetentionCategory(
        this.provider.taxData.otrosIdRetentionRegime
      )
      // this.getSussRetentionCategory()
      this.generalData.idProvince = this.provider.generalData.idProvince
      Object.assign(this.paymentData, this.provider.paymentData)
      Object.assign(this.taxData, this.provider.taxData)
      this.dataAfip = 'a'
      // let i = 0
      if (!this.idStep) {
        this.step = parseInt(this.provider.idStage - 1)
      }
      for (var key in this.provider) {
        // skip loop if the property is from prototype
        if (!this.provider.hasOwnProperty(key)) continue

        var obj = this.provider[key]
        if (obj && obj.hasOwnProperty('idCompanyDataStatus')) {
          if (obj.idCompanyDataStatus !== status.ACEPTADO) {
            // this.step = i
            this.disabledGeneralData()
            return
          }
          // i++
        }
      }
    },
    checkProviderData () {
      if (this.provider && this.idCompany) {
        this.loadProvider()
      } else {
        this.addJurisdiction()
      }
    },
    solicitudActivarUsuario (stage = null) {
      if (!stage) {
        stage = this.provider.idStage
      }
      const companyName = this.provider.company
      const idFiscal = this.provider.cuit
      api
        .request(
          'GET',
          'api/solicitudActivarUsuario' + '?stage=' + stage + '&idFiscal=' + idFiscal + '&companyName=' + companyName
        )
        .then((response) => {
          this.toggleLoading()
        })
        .catch((error) => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error)

          this.response =
            'Error al conectarse con el servidor, contacte al administrador.'
          this.toggleLoading()
        })
    },
    setIbJurisdiction () {
      // console.log('jurisdictions', this.provider.taxData.jurisdictions)
      setTimeout(() => {
        this.provider.taxData.jurisdictions.forEach((jur, index) => {
          this.updateAliquot(
            this.provider.taxData.jurisdictions[index]['idJurisdiction'], index
          )
        })
      }, 500)
    },
    getJurisdictionsHabilitadas () {
      api
        .request('GET', 'api/getEnabledJurisdictions')
        .then((response) => {
          const data = response.data
          if (data.error) {
            return
          }
          if (data) {
            // console.log('jurisdictionshabilitadas', JSON.parse(data.data[0].stringValue.replace('{', '').replace('}', '')))
            console.log('jurisdictions habilitadas', data.data)
            this.jurisdictionsHabilitadas = data.data
            console.log('store', this.$store.state.jurisdictions)
          }
        })
        .catch((error) => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
    }
  },
  beforeMount () {
    this.actualCountry = this.$route.params.country
    console.log(this.actualCountry)
    this.isSystemAdmin()
    this.companyData()
    this.getCentrales()
    // this.setRetentionRegime()
    // this.getSussRetentionCategory()
    // this.updateRetentionCategory(this.taxData.retentionRegimen)
  },
  mounted () {
    this.getJurisdictionsHabilitadas()
    console.log(this.user.roles)
    if (
      this.user &&
      this.user.isProvider &&
      this.idCompany &&
      this.idCompany !== this.user.company.idCompany
    ) {
      this.$router.push('/')
    }
    this.checkProviderData()
    // this.getSussRetentionCategory()
    this.providerLoaded = false
    api
      .request('get', 'api/checkParam?id=AP-001')
      .then((response) => {
        var data = response.data

        if (data.error) {
          if (!this.user) {
            this.paramError = data.error
          }
        }
      })
      .catch((error) => {
        console.log(error)
      })
    api
      .request('get', 'api/findConfiguration/TYC')
      .then((response) => {
        this.configuration = response.data['value']
      })
      .catch((error) => {
        console.log(error)
      })
    api
      .request('get', 'api/findConfiguration/CODETI')
      .then((response) => {
        this.codigoEtica = response.data['value']
      })
      .catch((error) => {
        console.log(error)
      })
    api
      .request('get', 'api/findConfiguration/POLANTI')
      .then((response) => {
        this.politicaAnticorrupcion = response.data['value']
      })
      .catch((error) => {
        console.log(error)
      })
    api
      .request('get', 'api/findConfiguration/POLREL')
      .then((response) => {
        this.politicaRelacionamiento = response.data['value']
      })
      .catch((error) => {
        console.log(error)
      })
    api
      .request('get', 'api/checkParam?id=SUF-001')
      .then((response) => {
        var data = response.data

        if (data.error) {
          this.paramInvoices = data.error
        }
      })
      .catch((error) => {
        console.log(error)
      })
    if (this.idStep) {
      this.step = parseInt(this.idStep)
    }
    this.disabledGeneralData()
  }
}
</script>

<style>
.tg {
  border-collapse: collapse;
  border-spacing: 0;
  border-color: #ccc;
  margin-left: auto;
  margin-right: auto;
}
.tg td {
  font-family: Arial, sans-serif;
  font-size: 14px;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: #ccc;
  color: #333;
  background-color: #fff;
}
.tg th {
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: #ccc;
  color: #333;
  background-color: #f0f0f0;
}
.tg .tg-buh4 {
  background-color: #f9f9f9;
  text-align: left;
  vertical-align: top;
}
.td-buh4A {
  padding-top: 15px;
  text-align: left;
  vertical-align: top;
}
.td-buh4B {
  padding-top: 12px;
  text-align: left;
  vertical-align: top;
}
.tg .tg-0lax {
  text-align: left;
  vertical-align: top;
}
.tg-0laxA {
  text-align: left;
  vertical-align: top;
  margin-bottom: -50px;
}
.tg .tg-j58y {
  background-color: #f9f9f9;
  text-align: left;
  vertical-align: bottom;
}
.el-row {
  margin-bottom: 0px;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.bg-font {
  font-family: arial;
  font-size: 16px;
}
.grid-content {
  min-height: 25px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.datetime-picker input {
  height: 4em !important;
}
.el-select {
  width: 400px;
}
.entradas {
  padding: 5px 2px 5px 2px;
}

.entradas_min {
  padding: 1px 1px 5px 1px;
}

/*----------PAPER-----------*/
/* form starting stylings ------------------------------- */
.group {
  position: relative;
  margin-bottom: 45px;
}
input {
  font-size: 18px;
  padding: 10px 10px 10px 5px;
  display: block;
  width: 100%;
  border: none;
  border-bottom: 1px solid #757575;
}
input:focus {
  outline: none;
}

/* LABEL ======================================= */
.el-form-item__label {
  color: #999;
  font-weight: normal;
  position: initial !important;
  pointer-events: none;
  top: initial !important;
  left: initial !important;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
/* active state */
/*input:focus ~ label, input:valid ~ label    {
  top:-20px;
  font-size:14px;
  color:#5264AE;
}*/

/* BOTTOM BARS ================================= */
.bar {
  position: relative;
  display: block;
  width: 100%;
}
.bar:before,
.bar:after {
  content: '';
  height: 2px;
  width: 0;
  bottom: 1px;
  position: absolute;
  background: #5264ae;
  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
}
.bar:before {
  left: 50%;
}
.bar:after {
  right: 50%;
}

.record {
  padding-left: 101%;
  padding-top: 500%;
}

/* active state */
input:focus ~ .bar:before,
input:focus ~ .bar:after {
  width: 50%;
}

/* HIGHLIGHTER ================================== */
.highlight {
  position: absolute;
  height: 60%;
  width: 100px;
  top: 25%;
  left: 0;
  pointer-events: none;
  opacity: 0.5;
}

/* active state */
input:focus ~ .highlight {
  -webkit-animation: inputHighlighter 0.3s ease;
  -moz-animation: inputHighlighter 0.3s ease;
  animation: inputHighlighter 0.3s ease;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type='number'] {
  -moz-appearance: textfield; /* Firefox */
}

/* ANIMATIONS ================ */
@-webkit-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@-moz-keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}
@keyframes inputHighlighter {
  from {
    background: #5264ae;
  }
  to {
    width: 0;
    background: transparent;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
#formDatosImpositivos div div div div div div div div div.el-form-item__error {
  position: initial !important;
}
#formDatosImpositivos div div div div div div div.el-form-item__error {
  position: initial !important;
}
</style>



// WEBPACK FOOTER //
// ConfirmProvider.vue?62be358f